/* eslint-disable max-len */
import {
  Box,
  Button,
  DialogContent,
  Grid,
  GridProps,
  Menu,
  MenuItem,
  Skeleton,
  styled,
  Typography,
  Badge,
  Rating,
  Dialog as MuiDialog,
  Button as MuiButton,
  TextField,
  useMediaQuery,
  useTheme,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import DrawIcon from "@mui/icons-material/Draw";
import { DocumentType } from "../../components/DigitalSignature";

import Profile from "./index";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useAxios } from "../../services/http.service";
import ApiRoutes from "../../config/api.routes";
import { EmptyBox } from "./Guarding";
import { checkTransactionConfirmationReceipt, sizing, toReadable } from "../../utils/methods";
import {
  Text,
  TableSchema,
  TableComponent,
  ActionBtn,
  AddressLink,
  PulseCircle,
  CurrencyLabel,
  OrgPopUp,
  TruncatedText,
} from "../../components";
import { generatePath, useLocation, useNavigate } from "react-router-dom";
import { AppRoutes, landDetailLink } from "../../config";
import { TabsRow } from "../EcoBank/TrustWallet";
import { ClickableContainer, formatRelativeTime, Img, Link } from "../../utils/table-schemas";
import { LandToken } from "../../types/LandToken";

import { MapLink } from "../Home/Home";

import { formatValue } from "../../utils/formatValue";
import { resolveStandardStatus } from "../../utils/standard-status";
import { CURRENCY_NAME, EcoTokenStatus, onReassignment, onVerification } from "../../utils/constants";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import { useProfileDataCache } from "../../contexts/ProfileDataCache";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import InfoIconOutlined from "@mui/icons-material/InfoOutlined";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { getContract, getMetaMaskSigner, getReadOnlyContract } from "../../services/contract.service";
import { fetchCovenantReviewState } from "../../hooks/useCovenantReviewState";
import { chainErrorCopy, describeChainError, listRecentChallengeSubjects } from "../../services/challenge.service";
import { relayContractCall, isUserRejection } from "../../services/relay.service";
import { PopupActionButton, PopupGhostButton, PopupProcessingButton } from "../../components/PopupButtons";
import { TableWithTabs } from "../EcoBank/UserWallet";
import { DetailsPopup } from "../../components/TransactionDetails/DetailsPopup";
import ComplaintModal from "../LandVerification/ComplaintModal";
import useUntakenRequests from "./useUntakenRequests";
import { modalTransitionProps, tooltipTransitionProps } from "../../components/ScaleTransition";
import PanelTransition from "../../components/Notifications/PanelTransition";
import {
  EASE_IN_OUT,
  TEXT_SWAP_DISTANCE,
  TEXT_SWAP_MS,
  TOOLTIP_DELAY_MS,
  hoverTint,
  pressDip,
  swapInSx,
} from "../../styles/motion";
import { toApplicantRow } from "../../components/ApplicantReview/applicantRow";
import { PortalLocationState, applicantReviewPath } from "./ApplicantReview/navigation";
import useAuthorization from "../../contexts/useAuthorization";
import { GlobalTrustAdminMonoIcon } from "../../components/RoleIcons";
import { ZeroAddress, isAddress } from "ethers";

// Pending Reassignment Types
interface PendingReassignmentUser {
  id: number;
  address: string;
  name: string;
  uuid: string;
  role: string;
  email: string;
  emailVerified: boolean;
  status: string;
  username: string | null;
  bio: string | null;
  kycLvl: number;
  firstName: string | null;
  lastName: string | null;
  patronymic: string | null;
  profileImageUrl: string | null;
  referrerAddress: string | null;
  referrerCode: string | null;
  lastReferredAt: string | null;
  countryCode: number;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  phone: string | null;
  country: string | null;
  proofOfId: string | null;
  profilePicture: string | null;
  trusteeStatus: string | null;
  trustStatus: string | null;
  dismissedReason: string | null;
}

interface PendingReassignmentEtNft {
  id: number;
  tokenId: number;
  minterAddress: string;
  ownerAddress: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  totalTreeForEasement: string;
  countryCode: number;
}

interface PendingReassignmentEcoToken {
  id: number;
  uuid: string;
  minterId: number;
  minterAddress: string;
  ownerAddress: string;
  contractAddress: string | null;
  tokenId: number | null;
  status: string;
  content: string;
  trustId: number | null;
  ecoScore: number;
  mintRateUsd: string | null;
  treeMintMax: string | null;
  treeMinted: string | null;
  verifiedAt: string | null;
  mintedAt: string | null;
  expiresAt: string | null;
  lastVerified: string | null;
  createdAt: string;
  updatedAt: string;
  referrerAddress: string | null;
  offerStatus: string | null;
  etNft: PendingReassignmentEtNft;
}

interface PendingReassignment {
  id: number;
  ecoTokenId: number;
  userId: number;
  newTrustAddress: string;
  r: string;
  s: string;
  v: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  user: PendingReassignmentUser;
  ecoToken: PendingReassignmentEcoToken;
}

interface ComplaintEcoToken {
  id: number;
  uuid: string;
  minterId: number;
  minterAddress: string;
  ownerAddress: string;
  contractAddress: string | null;
  tokenId: number | null;
  status: string;
  content: string;
  trustId: number | null;
  ecoScore: number;
  mintRateUsd: string | null;
  treeMintMax: string | null;
  treeMinted: string | null;
  verifiedAt: string | null;
  mintedAt: string | null;
  expiresAt: string | null;
  lastVerified: string | null;
  createdAt: string;
  updatedAt: string;
  referrerAddress: string | null;
  offerStatus: string | null;
  requestId?: string | null;
  feeAmount?: string | null;
  etNft: any | null;
  trust?: {
    address?: string | null;
    [key: string]: any;
  } | null;
  meta?: {
    name?: string | null;
    [key: string]: any;
  } | null;
}

interface ComplaintRow {
  id: number;
  tokenId: number;
  verificationId: number | null;
  guardianId: number;
  filerType: string;
  description: string | null;
  status: string;
  fileAliases: string[];
  fileUrls: string[];
  response: string | null;
  respondedBy: number | null;
  respondedAt: string | null;
  createdAt: string;
  updatedAt: string;
  ecoToken: ComplaintEcoToken | null;
  fileCount: number;
}

const normalizeComplaintRows = (complaints: ComplaintRow[] = []) => {
  const normalized = complaints.map((complaint) => {
    const fileUrls = Array.isArray(complaint.fileUrls) ? complaint.fileUrls : [];
    const fileAliases = Array.isArray(complaint.fileAliases) ? complaint.fileAliases : [];
    const landName = complaint.ecoToken?.meta?.name ?? null;
    const landImage = complaint.ecoToken?.content ?? null;

    return {
      ...complaint,
      fileUrls,
      fileAliases,
      fileCount: fileUrls.length || fileAliases.length,
      ecoTokenId: complaint.ecoToken?.id ?? complaint.tokenId,
      ecoTokenStatus: complaint.ecoToken?.status ?? "-",
      ecoTokenLastVerified: complaint.ecoToken?.lastVerified ?? null,
      landName,
      landImage,
      content: complaint.ecoToken?.content ?? null,
      meta: complaint.ecoToken?.meta ?? null,
      trust: complaint.ecoToken?.trust ?? null,
    };
  });

  console.log("Portal: complaints table data", normalized);

  return normalized;
};

// The land an Ecofutures row is about, for its Land and Name links — the same page the row's
// Inspect opens, so a name never leads somewhere Inspect would not. Unminted lands (pre-mint
// challenges, untaken requests, the claimed / reassignment queue) are included: this tab's
// readers are admins, and an admin (Trust Admin / GTA seat) skips the ownership check on
// /user/eco-tokens/:id, which is what the embedded LandPage falls back to when get-full-data has
// no NFT to return. null when there is no land to open.
const ecoFuturesLandId = (data: any): string | null => {
  // A complaint row is spread from the complaint, so its `id` is the complaint's, not the land's.
  if (data?.isComplaint) {
    return data?.ecoTokenId ?? null;
  }
  // The join found no eco-token carrying this requestId.
  if (data?.isUntakenRequest && !data?.landFound) {
    return null;
  }
  return data?.id ?? null;
};

// A challenged deed (V9.1 settlement) rendered as an Ecofutures row. GET /settlement?state=
// challenged answers with bare EtNft rows — no meta, no content, no trust — so each one is
// joined to its EcoToken to fill the Land / Name / Location / Trust columns. `etNft.tokenId` is
// the FK to eco_token.id (EtNft joins ecoToken on it), which is also what landDetailLink wants.
//
// The per-row join is an N+1, which is affordable precisely because a challenged deed is rare
// and terminal-ish: it sits there until the drawn checker's determination is recorded. /eco-token/:id is public-cached
// server-side, and the list is capped below, so the worst case is a bounded burst.
const CHALLENGED_ROW_LIMIT = 25;

const normalizeTrusteeLikeRows = (rows: any[] = []) => {
  return rows.map((row: any, index: number) => ({
    ...row,
    id: row?.id ?? row?.uuid ?? row?.address ?? `admin-${index}`,
    address: row?.address ?? "",
    orgName: row?.orgName ?? "-",
    status: row?.status ?? "-",
    flags: Array.isArray(row?.flags) ? row.flags : [],
    portfolio: {
      ...(row?.portfolio ?? {}),
      claimedLandsCount: row?.portfolio?.claimedLandsCount ?? 0,
      portfolioSum: row?.portfolio?.portfolioSum ?? "0",
      claimedLands: Array.isArray(row?.portfolio?.claimedLands) ? row.portfolio.claimedLands : [],
    },
  }));
};

const Portal = () => {
  const axios = useAxios();
  const { user, isGlobalTrustAdmin } = useAuthorization();
  const { getCachedData, profileCache, refreshProfileData } = useProfileDataCache();
  // V10.1.2: verification requests no verifier took, refundable to the guardian once the
  // acceptance window has passed. Rows of the Ecofutures table, each carrying its own refund;
  // empty unless the viewer is a Trust Admin or GTA with one in scope.
  const untakenRequests = useUntakenRequests(user?.address ?? null, refreshProfileData);
  // IPFS legal documents awaiting this admin's signature. A trustee/user row
  // becomes signable when it is the *creator* of one of these pending documents
  // (matched by id) — mirrors the trust-side flow in Verifications.tsx.
  const adminPendingDocumentIds = React.useMemo(
    () =>
      new Set<number>((user?.pendingDocuments ?? []).map((doc) => doc?.id).filter((id): id is number => id != null)),
    [user?.pendingDocuments]
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const [isLoading, setLoading] = useState(true);
  // const [data, setData] = useState([]);
  // Admins tab (and the on-chain Holder grant it exposes) is global-Trust-Admin-only —
  // country-scoped admins must land on "trustee", matching the hidden tab button below.
  // Conversely the Trustee / New Trustee tabs are country-admin-only: a GTA never sees them.
  // The applicant review (its own page, ApplicantReview/) comes back here on the tab it was opened
  // from, in router state — which the browser's Back arrives with too, as openApplicantReview
  // leaves it on this page's history entry.
  const location = useLocation();
  const returnedWith = (location.state ?? null) as PortalLocationState | null;
  const [activeTab, setActiveTab] = useState<"trustee" | "ecofutures" | "newTrustee" | "admins">(
    returnedWith?.tab ?? (isGlobalTrustAdmin ? "admins" : "trustee")
  );
  // isGlobalTrustAdmin is false on first render (useAuthorization resolves the user, then the
  // Governance GTA read, asynchronously), so the initialiser above always picks "trustee" on a
  // fresh load. Follow it to "admins" once it settles — but only until the user picks a tab,
  // unless the tab they picked in the meantime is one a GTA doesn't get. A tab handed back by the
  // review counts as picked.
  const tabChosenByUser = React.useRef(!!returnedWith?.tab);
  const chooseTab = (tab: typeof activeTab) => {
    tabChosenByUser.current = true;
    setActiveTab(tab);
  };
  useEffect(() => {
    if (!isGlobalTrustAdmin) return;
    setActiveTab((tab) => (!tabChosenByUser.current || tab === "trustee" || tab === "newTrustee" ? "admins" : tab));
  }, [isGlobalTrustAdmin]);
  const [trusteeData, setTrusteeData] = useState<any[]>([]);
  const [unverifiedEFData, setUnverifiedEFData] = useState<any[]>([]);
  const [complaintsData, setComplaintsData] = useState<any[]>([]);
  // Deeds challenged during post-auction settlement, awaiting the drawn checker's determination (V10.1).
  const [challengedData, setChallengedData] = useState<any[]>([]);
  // Live easements whose TREE drip is frozen by a covenant-term challenge — the same shape of
  // queue, but for the post-settlement lifecycle rather than the sale.
  const [termChallengedData, setTermChallengedData] = useState<any[]>([]);
  // Verifications challenged BEFORE the mint — the earliest of the three challenge mechanisms.
  // Rows are eco-tokens, not EtNfts: nothing is minted, so there is no NFT and no settlement.
  const [preMintChallengedData, setPreMintChallengedData] = useState<any[]>([]);
  // const { isAdmin } = useAuthorization();
  const [selectedUser, setSelectedUser] = useState<any>(null);
  // The on-chain Holder grant is independent of org creation/approval (see
  // TRUST_ADMIN_ONBOARDING guide §2/§7) — an "accepted" trust admin (org already
  // submitted, approval/on-chain grant still pending) must still route to
  // handleVerifyAdmin, not the Trust/Verifier handleVerifyUser path.
  const isTrustAdminApproval =
    selectedUser?.trustAdminStatus === "invited" || selectedUser?.trustAdminStatus === "accepted";
  const [approveOpen, setApproveOpen] = useState(false);
  // Verifier applications are approved on their own page (details → deed → approve), not through
  // the bare confirm above — see openApplicantReview.
  // Why the last "Approve applicant" attempt failed, shown inside the approve dialog. Without
  // this the on-chain path failed silently: a revert was console.log'd and the dialog just sat there.
  const [approveError, setApproveError] = useState("");
  const [reassignOpen, setReassignOpen] = useState(false);
  const [ecoFuturesData, setEcoFuturesData] = useState<any>(null);
  const [inspectModalView, setInspectModalView] = useState(0); // 0 for user, 1 for organization
  const [unverifiedData, setUnverifiedData] = useState<any[]>([]);
  const [verifiedData, setVerifiedData] = useState<any[]>([]);
  const [adminsData, setAdminsData] = useState<any[]>([]);
  // Drives the Admins table's skeleton on its first load only. Later refetches (re-entering the
  // tab) are silent, so the rows already on screen don't flash back to a skeleton.
  const [adminsLoading, setAdminsLoading] = useState(true);
  // Add state for selected menu ID

  const [selectedMenuId, setSelectedMenuId] = useState<string | null>(null);
  const [searchValue, setSearchValue] = useState<string>("");
  const [reassignTab, setReassignTab] = useState<"search" | "all">("search");
  const [pendingReassignees, setPendingReassignees] = useState<PendingReassignment[]>([]);
  const [loadingPendingReassignees, setLoadingPendingReassignees] = useState<boolean>(false);
  const [complaintModalOpen, setComplaintModalOpen] = useState(false);
  const [selectedComplaint, setSelectedComplaint] = useState<any>(null);
  const [complaintModalLoading, setComplaintModalLoading] = useState(false);
  const [complaintModalError, setComplaintModalError] = useState<string | null>(null);
  // Dismiss-verifier dialog (relay lane) — dismissVerifier requires a judgedFinding
  // string on-chain, so a reason must be collected before signing.
  const [dismissTarget, setDismissTarget] = useState<string | null>(null);
  const [dismissReason, setDismissReason] = useState("");
  const [dismissLoading, setDismissLoading] = useState(false);
  const [dismissError, setDismissError] = useState<string | null>(null);
  // Release-verification-funds dialog (relay lane) — resolutionType: 1 refund guardian,
  // 2 bounty to beneficiary, 3 pay verifier (normal), 4 deed-check hold.
  const [releaseTarget, setReleaseTarget] = useState<any>(null);
  const [releaseResolutionType, setReleaseResolutionType] = useState(3);
  const [releaseBeneficiary, setReleaseBeneficiary] = useState("");
  const [releaseLoading, setReleaseLoading] = useState(false);
  const [releaseError, setReleaseError] = useState<string | null>(null);
  const navigator = useNavigate();
  useEffect(() => {
    setOpen(false);
    setApproveOpen(false);
  }, []);

  const fetchPendingReassignees = async () => {
    setLoadingPendingReassignees(true);
    try {
      if (!ecoFuturesData?.id) return;
      const response = await axios.get(ApiRoutes.admin.pendingReassign(ecoFuturesData.id)).then((res) => res.data);
      setPendingReassignees(response);
      setLoadingPendingReassignees(false);
      console.log("Pending Reassignees:", response);
    } catch (error) {
      console.error("Error fetching pending reassignees:", error);
    }
  };

  useEffect(() => {
    fetchPendingReassignees();
  }, [ecoFuturesData]);

  const handleVerifyAdmin = async (user: any) => {
    setLoading(true);
    try {
      // documentURI = the finalized (fully-countersigned) verifier engagement doc this
      // admin created — same doc the "Approve" gate in adminSchema requires signed
      // before this action is reachable (see pendingVerifierEngagement above).
      const verifierEngagementDoc = (user?.signedDocuments || []).find(
        (doc: any) => doc?.type === DocumentType.VERIFIER_ENGAGEMENT && doc?.creator
      );
      const documentURI = verifierEngagementDoc?.finalGatewayUrl || "";

      // Direct MetaMask transaction — addHolder is a global-Trust-Admin-only action and
      // is deliberately NOT relayed (removed from the /relay allowlist); the caller pays
      // gas. Kept as a separate call from org approval (handleApproveOrganization below)
      // — the "Approve" menu item is disabled in adminSchema until the org is verified,
      // so this only ever fires once org approval has already happened (or for a
      // still-"invited" admin with no org yet, where there's nothing to approve).
      const signer = await getMetaMaskSigner();
      const contract = getContract("ecofutures-admin", signer);
      if (!contract) {
        throw new Error("Contract not found");
      }
      const args = [user.address, user.countryCode, user?.orgID, documentURI] as const;

      // Simulate first, through the plain JSON-RPC provider. ethers runs eth_estimateGas before
      // it asks MetaMask to sign, and the connect-evm SDK routes that call to its own read-only
      // RPC — whose client returns `response.result` and drops `response.error`. A revert there
      // therefore comes back as `null`, and ethers throws "invalid BigNumberish value" with no
      // revert data, so nothing can be decoded. The read-only provider keeps the data, and
      // describeChainError turns it into copy (e.g. InvalidCountryCode).
      const adminRO = getReadOnlyContract("ecofutures-admin");
      if (adminRO) {
        await adminRO.addHolder.staticCall(...args, { from: await signer.getAddress() });
      }

      const tx = await contract.addHolder(...args);
      await checkTransactionConfirmationReceipt(tx.hash);
      await refreshProfileData();
      setApproveOpen(false);
    } catch (e: any) {
      console.error("[handleVerifyAdmin] addHolder failed:", e);
      setApproveError(isUserRejection(e) ? "Cancelled in your wallet — nothing was sent." : describeChainError(e));
    } finally {
      setLoading(false);
    }
  };

  // Approves/rejects a Trust-Admin-created organization — a separate call from the
  // on-chain Holder grant above. Restricted in the UI to global Trust Admins
  // (isGlobalTrustAdmin); backend enforces the same via 403 globalAdminRequired.
  const handleApproveOrganization = async (orgID: string | number, verified: boolean) => {
    setLoading(true);
    try {
      await axios
        .put(ApiRoutes.admin.verifyOrganization(orgID), { verified, comment: verified ? "Approved" : "Rejected" })
        .then((res) => res.data);
      await refreshProfileData();
    } catch (e: any) {
      console.log({ e });
    } finally {
      setLoading(false);
    }
  };

  const handleReassignOpen = (data: any) => {
    setReassignOpen(true);
    setEcoFuturesData(data);
    console.log(data, reassignOpen);
    setSearchValue("");
    setSelectedUser(null);
    setAnchorEl(null);
  };

  const handleUnblockOpen = async (data: any) => {
    setEcoFuturesData(data);
    try {
      const signer = await getMetaMaskSigner();
      const contract = getContract("ecofutures-core", signer);

      if (contract) {
        const tx = await contract.unblockVerifiedEasement(data?.id);
        const r = await checkTransactionConfirmationReceipt(tx.hash);
        console.log({ r });
        const receipt = r as any;
        if (receipt?.status !== "0") {
        }
      } else {
        throw new Error("Contract not found");
      }
    } catch (e: any) {
      console.log({ e });
    } finally {
      setSearchValue("");
      setSelectedUser(null);
      setAnchorEl(null);
    }
  };
  const handleCancelOpen = async (data: any) => {
    setEcoFuturesData(data);
    try {
      const signer = await getMetaMaskSigner();
      const contract = getContract("ecofutures-core", signer);

      if (contract) {
        const tx = await contract.cancelVerifiedEasement(data?.id);
        const r = await checkTransactionConfirmationReceipt(tx.hash);
        console.log({ r });
        const receipt = r as any;
        if (receipt?.status !== "0") {
        }
      } else {
        throw new Error("Contract not found");
      }
    } catch (e: any) {
      console.log({ e });
    } finally {
      setSearchValue("");
      setSelectedUser(null);
      setAnchorEl(null);
    }
  };
  // Opens the release-funds dialog; the on-chain call happens in confirmReleaseFunds
  // once the holder has picked a resolution type.
  const handleReleaseFundsOpen = (data: any) => {
    setEcoFuturesData(data);
    setReleaseTarget(data);
    setReleaseResolutionType(3);
    setReleaseBeneficiary("");
    setReleaseError(null);
    setSearchValue("");
    setSelectedUser(null);
    setAnchorEl(null);
  };

  const confirmReleaseFunds = async () => {
    const requestId = releaseTarget?.requestId;
    if (requestId === undefined || requestId === null) {
      setReleaseError("Missing requestId for this verification");
      return;
    }
    // Resolution 2 (bounty) and 4 (deed-check hold) pay out to a beneficiary; the other
    // paths ignore the address, so the zero address is passed for them.
    const needsBeneficiary = releaseResolutionType === 2 || releaseResolutionType === 4;
    if (needsBeneficiary && !isAddress(releaseBeneficiary)) {
      setReleaseError("Enter a valid beneficiary wallet address");
      return;
    }
    setReleaseLoading(true);
    setReleaseError(null);
    try {
      // Gasless lane (holder pays no BNB): one EIP-712 signature → backend /relay →
      // resolved only once VerificationFundsReleased is observed on-chain.
      await relayContractCall(
        "ecofutures-admin",
        "releaseVerificationFunds",
        [requestId, releaseResolutionType, needsBeneficiary ? releaseBeneficiary : ZeroAddress],
        "VerificationFundsReleased",
        "Release verification funds"
      );
      setReleaseTarget(null);
      await refreshProfileData();
    } catch (e: any) {
      console.log({ e });
      if (!isUserRejection(e)) {
        // V10.1.2 adds ChallengeOpen (a pre-mint challenge still stands) and AlreadyFulfilled (a
        // type 4 release after the mint) here; the protocol copy names them.
        setReleaseError(chainErrorCopy(e) ?? (e?.message || "Failed to release verification funds"));
      }
    } finally {
      setReleaseLoading(false);
    }
  };

  const handleReassignClose = () => {
    setReassignOpen(false);
    setTimeout(() => {
      setSelectedUser(null);
      setReassignTab("search");
      setAnchorEl(null);
      setSearchValue("");
    }, 300);
  };

  const handleModalOpen = () => {
    setInspectModalView(0);
    setOpen(true);
  };

  // The review is its own page. The row rides along in router state so the page can paint at once
  // (it loads the applicant itself from the address, and does not need it). This entry is first
  // stamped with the tab it is on, so the review's exits and the browser's own Back both come back
  // to it.
  const openApplicantReview = (applicant: any) => {
    if (!applicant?.address) {
      return;
    }
    const returnState: PortalLocationState = { tab: activeTab };
    navigator(location.pathname, { replace: true, state: returnState });
    navigator(applicantReviewPath(applicant.address), { state: { applicant } });
  };

  // A standing verification challenge — pre-mint or covenant — is judged on the land's
  // verification page, where the record under review is and where the challenger raised it: the
  // top bar there offers Judge, prefilled with the challenge. Stamped with the tab first, like the
  // applicant review, so the page's exits (it hands `refState` back) and the browser's own Back
  // both return here.
  const openVerificationToJudge = (landId: string | number) => {
    const returnState: PortalLocationState = { tab: activeTab };
    navigator(location.pathname, { replace: true, state: returnState });
    navigator(generatePath(AppRoutes.Verification.path, { tokenId: String(landId) }), {
      state: { ref: location.pathname, refState: returnState },
    });
  };

  const handleModalClose = () => {
    setSelectedUser(null);
    setInspectModalView(0);
    setOpen(false);
  };

  // Update handleClick to include row ID
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>, data: any) => {
    setSelectedUser(data);
    setInspectModalView(0); // Default to user view
    setSelectedMenuId(data.id); // Use unique ID from data
    setAnchorEl(event.currentTarget);
  };

  // Update handleClose to clear ID
  const handleClose = () => {
    setSelectedMenuId(null);
    setAnchorEl(null);
  };

  const handleComplaintInspectOpen = (data: any) => {
    console.log("Complaint data:", data);
    setSelectedComplaint(data);
    setComplaintModalOpen(true);
    setComplaintModalError(null);
  };

  const handleComplaintModalClose = () => {
    setComplaintModalOpen(false);
    setSelectedComplaint(null);
    setComplaintModalError(null);
  };

  const handleComplaintSubmit = async (data: any) => {
    setComplaintModalLoading(true);
    setComplaintModalError(null);
    try {
      const decision = String(data?.decision ?? "").toLowerCase();
      const filerType = String(selectedComplaint?.filerType ?? selectedComplaint?.filertype ?? "").toLowerCase();

      if (!selectedComplaint?.id) {
        throw new Error("Complaint not found.");
      }

      let response = "";
      let status = "";

      switch (`${decision}:${filerType}`) {
        case "accept:trust":
          response = "Trust complaint accepted.";
          status = "resolved";
          break;
        case "reject:trust":
          response = "Trust complaint rejected.";
          status = "dismissed";
          break;
        case "accept:guardian":
          response = "Guardian complaint accepted.";
          status = "resolved";
          break;
        case "reject:guardian":
          response = "Guardian complaint rejected.";
          status = "dismissed";
          break;
        default:
          throw new Error("Unsupported complaint decision.");
      }

      await axios.patch(ApiRoutes.trust.complaints.respond(selectedComplaint.id), {
        response,
        status,
      });

      await refreshProfileData();
      handleComplaintModalClose();
    } catch (e: any) {
      setComplaintModalError(e.message || "Failed to process complaint. Please try again.");
    } finally {
      setComplaintModalLoading(false);
    }
  };

  // Opens the dismiss dialog; the on-chain call happens in confirmDismissVerifier —
  // dismissVerifier requires a judgedFinding reason, collected there.
  const blockTrustee = (address: string) => {
    setDismissTarget(address);
    setDismissReason("");
    setDismissError(null);
    setAnchorEl(null);
  };

  const confirmDismissVerifier = async () => {
    if (!dismissTarget) {
      return;
    }
    if (!dismissReason.trim()) {
      setDismissError("A reason (judged finding) is required to dismiss a trustee");
      return;
    }
    setDismissLoading(true);
    setDismissError(null);
    try {
      // Gasless lane (holder pays no BNB): one EIP-712 signature → backend /relay →
      // resolved only once VerifierDismissed is observed on-chain.
      await relayContractCall(
        "ecofutures-admin",
        "dismissVerifier",
        [dismissTarget, dismissReason.trim()],
        "VerifierDismissed",
        "Dismiss trustee"
      );
      setDismissTarget(null);
      await refreshProfileData();
    } catch (e: any) {
      console.log({ e });
      if (!isUserRejection(e)) {
        setDismissError(e?.message || "Failed to dismiss trustee");
      }
    } finally {
      setDismissLoading(false);
    }
  };

  const handleOrgClick = (e: React.MouseEvent, data: any) => {
    e.stopPropagation();
    console.log("handleOrgClick fired with data:", data);
    setSelectedUser(data);
    setInspectModalView(1);
    setOpen(true);
  };

  // Lands to feed OrgPopUp's hero card. `orgVerifiedLands` entries are thin
  // (only name/image/meta/ecoScore — no content/etNft), while the rich land
  // objects (with content + etNft) live in each same-org trustee's
  // `portfolio.claimedLands`. Enrich the verified lands by matching id so the
  // hero card renders fully; fall back to the rich lands, then the thin ones.
  const selectedOrgLands = React.useMemo(() => {
    if (!selectedUser) return null;

    const sameOrgTrustees = trusteeData.filter((t) => t.orgID === selectedUser?.orgID);
    const richLands: any[] = [
      ...sameOrgTrustees.flatMap((t) => (Array.isArray(t?.portfolio?.claimedLands) ? t.portfolio.claimedLands : [])),
      ...(Array.isArray(selectedUser?.portfolio?.claimedLands) ? selectedUser.portfolio.claimedLands : []),
    ];
    const richById = new Map<any, any>(richLands.map((l: any) => [l?.id, l]));

    const verifiedLands = Array.isArray(selectedUser?.orgVerifiedLands) ? selectedUser.orgVerifiedLands : [];
    const enrichedVerified = verifiedLands.map((vl: any) => richById.get(vl?.id) ?? vl);

    return enrichedVerified.length > 0 ? enrichedVerified : richLands.length > 0 ? richLands : null;
  }, [selectedUser, trusteeData]);

  // const handleOrgModalClose = () => {
  //     setSelectedUser(null);
  //     setOrgOpen(false);
  // };

  // const { } = useMetaMask();

  const handleReassignToTrustee = async (address: any, id: any) => {
    setLoading(true);
    console.log({ address, id });
    if (ecoFuturesData.etNft) {
      try {
        const signer = await getMetaMaskSigner();
        const Contract = getContract("ecofutures-core", signer);
        if (Contract) {
          const expiry = Math.floor(Date.now() / 1000) + 14 * 24 * 60 * 60;
          const pendingNode = pendingReassignees.find(
            (p) => String(p.newTrustAddress).toLowerCase() === String(address).toLowerCase()
          );
          if (!pendingNode) throw new Error("Pending reassignee not found");
          const { r: signR, s: signS, v: signV } = pendingNode;

          const response = await Contract.addVerifierToEasement(
            ecoFuturesData.etNft.id,
            address,
            expiry,
            signR,
            signS,
            signV
          );
          console.log(response);
          if (response) {
            setReassignOpen(false);
            await refreshProfileData();
          }
        }
      } catch (e: any) {
        console.log({ e });
      } finally {
        setLoading(false);
      }
    } else {
      throw new Error("Easement data not found for reassignment");
    }
  };

  const handleReassignToken = async (address: any, id: any) => {
    setLoading(true);
    if (id) {
      try {
        const response = await axios.post(ApiRoutes.admin.reassignToken, {
          wallet: address,
          landId: id,
        });
        if (response) {
          setReassignOpen(false);
          await refreshProfileData();
        }
      } catch (e: any) {
        console.log({ e });
      } finally {
        setLoading(false);
      }
    } else {
      throw new Error("Easement data not found for reassignment");
    }
  };

  const trusteeSchema: TableSchema<any>[] = getTrusteeSchema({
    isSmallScreen,
    isLoading,
    anchorEl,
    selectedMenuId,
    navigator,
    handleOrgClick,
    handleClick,
    handleClose,
    handleModalOpen,
    blockTrustee,
    setApproveOpen,
    onReviewApplicant: () => openApplicantReview(selectedUser),
    adminPendingDocumentIds,
  });

  const adminSchema: TableSchema<any>[] = [
    {
      id: "name",
      label: "Admin",
      // style: { width: "270px" },
      // The theme pins every Skeleton to a 4px radius, so the circle has to be restated in sx.
      skeleton: () => (
        <Skeleton variant="circular" sx={{ width: sizing(50), height: sizing(50), borderRadius: "50%" }} />
      ),
      render: (data) => {
        return (
          //
          <Box sx={{ width: sizing(50), height: sizing(50), display: "flex", flexDirection: "column", gap: 1 }}>
            <Img alt="Thumb" sx={{ width: "100%", borderRadius: "50%" }} src={data?.profilePicture} />
            {/* <Text medium contrast normal>
                            {data.name}
                        </Text> */}
          </Box>
        );
      },
    },
    {
      id: "name",
      label: "Name",
      // style: { width: "270px" },
      render: (data) => {
        const renderFlags = () => {
          const icons: React.ReactNode[] = [];
          const totalFlags = Array.isArray(data?.flags) ? data.flags.length : 0;

          // Push flags in reverse order
          for (let i = totalFlags - 1; i >= 0; i--) {
            const hasMessage = true;

            icons.push(
              <Box
                key={i}
                sx={{
                  cursor: hasMessage ? "pointer" : "default",
                  "&:hover": hasMessage ? { opacity: 0.7 } : {},
                }}
              >
                <DetailsPopup transaction={data?.flags[i]} flag={true} />
              </Box>
            );
          }
          return icons;
        };

        return (
          <Text medium normal sx={{ flexDirection: "column", gap: 1 }}>
            <ClickableContainer>
              <Text contrast sx={{ alignItems: "center", gap: 1 }}>
                {data?.isGTA && (
                  <Tooltip title="Global Trust Admin">
                    <GlobalTrustAdminMonoIcon aria-label="Global Trust Admin" sx={{ width: "18px", height: "18px" }} />
                  </Tooltip>
                )}
                <AddressLink
                  sx={{
                    fontSize: isSmallScreen ? "14px" : "16px",
                    "& a.userAddress, & a.trustAddress": { textDecoration: "none" },
                    "& a.userAddress:hover, & a.trustAddress:hover": { textDecoration: "none" },
                  }}
                  type="user"
                  address={data.address}
                  links={false}
                  name={data.name}
                />
              </Text>
            </ClickableContainer>
            {(Array.isArray(data.flags) ? data.flags.length : 0) > 0 && (
              <Box sx={{ mb: sizing(10), display: "flex", alignItems: "center", gap: 0.5 }}>{renderFlags()}</Box>
            )}
          </Text>
        );
      },
    },
    {
      id: "organization",
      label: "Organization",
      sx: { width: sizing(60) },
      render: (data) => {
        const orgLabel =
          (data?.orgName && data.orgName !== "-" ? data.orgName : null) ?? data?.organization?.name ?? null;
        const hasOrg = Boolean(orgLabel);

        return (
          <Box
            onClick={hasOrg ? (e) => handleOrgClick(e, data) : undefined}
            sx={{ cursor: hasOrg ? "pointer" : "default", pointerEvents: hasOrg ? "auto" : "none" }}
          >
            <Text
              mono
              medium
              sx={{
                flexDirection: "column",
                gap: 1,
                color: hasOrg ? "text.primary" : "#565656",
                fontWeight: 500,
                textDecoration: hasOrg ? "underline" : "none",
              }}
            >
              {orgLabel ?? "No organization"}
            </Text>
          </Box>
        );
      },
    },
    {
      id: "area",
      label: "Country",
      render: (data, _index) => {
        return (
          <>
            <Text mono medium sx={{ flexDirection: "column", gap: 1, "& a": { color: "text.primary" } }}>
              {data?.country ? data?.country : data?.isGTA ? "Global" : "Not found"}
            </Text>
          </>
        );
      },
    },
    {
      id: "lastTxn",
      label: "Last Txn",
      render: (data, _index) => {
        return (
          <>
            <ClickableContainer
              onClick={() => navigator(generatePath(AppRoutes.UserWallet.path, { address: data.address }))}
              sx={{ cursor: "pointer", pointerEvents: "auto" }}
            >
              <Text medium sx={{ color: "text.primary", fontFamily: "monospace", textTransform: "lowercase" }}>
                {data?.lastTxn?.createdAt ? formatRelativeTime(data.lastTxn.createdAt) : "No transactions"}
                <ArrowOutwardIcon
                  sx={{
                    color: "black",
                    fontSize: "0.9rem",
                  }}
                />
              </Text>
            </ClickableContainer>
          </>
        );
      },
    },
    {
      id: "verified",
      label: "Verified",
      render: (data, _index) => {
        return (
          <>
            <Text mono medium sx={{ flexDirection: "column", gap: 1, "& a": { color: "text.primary" } }}>
              {/* A registry-only GTA row has no verified count to show (see fetchGtaRows). */}
              {data?.trusteesVerified ?? (data?.isGTA ? "-" : "0")}
            </Text>
          </>
        );
      },
    },
    {
      id: "status",
      label: "Status",
      // style: {
      //     width: "185px",
      // },
      render: (data) => {
        return (
          <>
            <Text mono medium sx={{ flexDirection: "column", gap: 1, "& a": { color: "text.primary" } }}>
              {data.status && data?.role === "user" ? "Unverified" : data.status}
            </Text>
          </>
        );
      },
    },
    {
      id: "actions",
      label: "Actions",
      render: (data) => {
        // Documents this row's trust admin *created* that still await this GTA's
        // signature (matched by id) — mirrors the trustee-side gate in
        // getTrusteeSchema below. The verifier-engagement doc gates approval: the
        // GTA must sign it before the "Approve" action unlocks.
        const pendingCreatorDocs = (data?.signedDocuments || []).filter(
          (doc: any) => doc?.creator && adminPendingDocumentIds?.has(doc?.id)
        );
        const verifierEngagementDoc = pendingCreatorDocs.find(
          (doc: any) => doc?.type === DocumentType.VERIFIER_ENGAGEMENT
        );
        const signableDocument = verifierEngagementDoc ?? pendingCreatorDocs[0] ?? null;
        const signableDocumentId = signableDocument?.id ?? null;
        const pendingVerifierEngagement = Boolean(verifierEngagementDoc);
        return (
          <>
            <Row sx={{ gap: "12px", justifyContent: "start" }}>
              <TableActionButton
                size="small"
                color="primary"
                disabled={isLoading}
                variant="outlined"
                sx={{ textTransform: "none" }}
                onClick={(event) => handleClick(event, data)}
              >
                ...
              </TableActionButton>
              <Menu
                id={`menu-${data.id}`}
                anchorEl={anchorEl}
                open={Boolean(anchorEl) && selectedMenuId === data.id}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                MenuListProps={{
                  sx: {
                    padding: 5,
                    "& .MuiMenuItem-root": {
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    },
                  },
                }}
              >
                {/* Common menu items for all roles */}
                <MenuItem
                  onClick={() => {
                    handleModalOpen();
                    handleClose();
                  }}
                >
                  <RemoveRedEyeOutlinedIcon />
                  <Typography sx={{ paddingLeft: 2 }}>Inspect</Typography>
                </MenuItem>
                {(Array.isArray(data?.flags) ? data.flags.length : 0) >= 3 && data?.status === "active" && (
                  <MenuItem onClick={() => blockTrustee(data.address)}>
                    <BlockOutlinedIcon sx={{ marginRight: 1 }} /> Block
                  </MenuItem>
                )}
                {/* <MenuItem onClick={handleClose}>
                                <EmailOutlinedIcon sx={{ marginRight: 1 }} /> Message
                            </MenuItem> */}
                {signableDocumentId != null && (
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      navigator(
                        generatePath(AppRoutes.DocumentSigner.path, { documentId: String(signableDocumentId) })
                      );
                    }}
                  >
                    <DrawIcon sx={{ marginRight: 1 }} /> Sign{" "}
                    {signableDocument?.type === DocumentType.VERIFIER_ENGAGEMENT ? "Verifier Engagement" : "Document"}
                  </MenuItem>
                )}

                {/* Conditional items for user role */}
                {data?.role === "user" && data?.status && (
                  <>
                    <Tooltip
                      title={pendingVerifierEngagement ? "Sign the verifier engagement document before approving" : ""}
                    >
                      {/* span lets the tooltip surface while the item is disabled */}
                      <span style={{ display: "block" }}>
                        <MenuItem
                          // A pending Trust-Admin org must be approved (below) before the
                          // on-chain Holder grant can be requested. A pending verifier
                          // engagement signature blocks approval too.
                          disabled={
                            (data?.createdByTrustAdmin && data?.orgVerified === false) || pendingVerifierEngagement
                          }
                          onClick={() => setApproveOpen(true)}
                        >
                          <CheckBoxOutlinedIcon sx={{ marginRight: 1 }} /> Approve
                        </MenuItem>
                      </span>
                    </Tooltip>
                  </>
                )}
                {/* Trust-Admin org approval — a separate call from the "Approve" (on-chain
                  Holder grant) action above, see TRUST_ADMIN_ONBOARDING guide §2/§7.
                  Restricted to global Trust Admins in the UI (backend enforces the same). */}
                {isGlobalTrustAdmin && data?.orgID && data?.createdByTrustAdmin && data?.orgVerified === false && (
                  <>
                    <MenuItem
                      onClick={() => {
                        handleApproveOrganization(data.orgID, true);
                        handleClose();
                      }}
                    >
                      <CheckBoxOutlinedIcon sx={{ marginRight: 1 }} /> Approve Organization
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleApproveOrganization(data.orgID, false);
                        handleClose();
                      }}
                    >
                      <WarningAmberOutlinedIcon sx={{ marginRight: 1 }} /> Reject Organization
                    </MenuItem>
                  </>
                )}
              </Menu>
            </Row>
          </>
        );
      },
    },
  ];
  const ecoFuturesSchema: TableSchema<any>[] = [
    {
      id: "content",
      label: "Land",
      sx: { width: sizing(55) },
      headerStyle: { width: sizing(55) },
      skeleton: () => {
        return <Skeleton sx={{ width: sizing(50), height: sizing(50) }} />;
      },
      render: (data) => {
        // An untaken request whose land the join could not find has nothing to show or link to.
        if (data?.isUntakenRequest && !data?.landFound) {
          return (
            <Box
              sx={{
                width: sizing(50),
                height: sizing(50),
                margin: "0 auto",
                borderRadius: "20px",
                backgroundColor: "action.hover",
              }}
            />
          );
        }
        // Links wherever the Name does — see ecoFuturesLandId for why unminted lands open too.
        const landId = ecoFuturesLandId(data);
        return (
          <Link
            sx={{ pointerEvents: landId ? "auto" : "none", width: sizing(50), height: sizing(50), margin: "0 auto" }}
            to={landDetailLink(landId || "")}
          >
            {/* Same 20px corners as the Lands page thumbnail (imgCol in table-schemas). */}
            <Img
              alt="Thumb"
              sx={{ width: "100%", objectFit: "cover", height: "100%", borderRadius: "20px" }}
              src={data.content}
            />
          </Link>
        );
      },
    },
    {
      id: "name",
      label: "Name",
      style: { width: "270px" },
      render: (data) => {
        const landId = ecoFuturesLandId(data);
        const name = (
          <Text medium normal sx={{ flexDirection: "column", gap: 1, "a:hover &": { color: "black" } }}>
            {/* 270px column less the cell's 24px right padding: a long place name ellipsises on
                one line and reveals itself on hover instead of wrapping onto a second row. */}
            <TruncatedText title={data?.meta?.name || ""} sx={{ maxWidth: 246 }} />
            {/* The request id is what the refund acts on — and all there is to name a row whose
                land the join could not find. */}
            {data?.isUntakenRequest && <Text sx={{ color: "text.disabled" }}>Request #{data.untaken.requestId}</Text>}
          </Text>
        );
        if (!landId) {
          return name;
        }
        // The shared Name column's link (nameCol in table-schemas): the text keeps its colour and
        // ClickableContainer's hover wash is the affordance. Its negative margin cancels its own
        // padding, so linking a name does not shift the row.
        return (
          <Link to={landDetailLink(landId)}>
            <ClickableContainer sx={{ flexDirection: "column", alignItems: "flex-start", maxWidth: "100%" }}>
              {name}
            </ClickableContainer>
          </Link>
        );
      },
    },
    {
      id: "location",
      label: "Location",
      render: (data) => {
        // An untaken request whose land the join could not find has no meta at all.
        if (!data.meta?.location) {
          return <Text sx={{ color: "text.disabled" }}>-</Text>;
        }
        if (typeof data.meta?.location === "string") {
          const loc = JSON.parse(data.meta.location as any);
          return (
            <MapLink
              sx={{ color: "primary.main", textTransform: "uppercase", textWrap: "balance" }}
              to={AppRoutes.Explore.path + "?id=" + data.id}
            >
              <span style={{ fontWeight: 500 }}>{loc?.name?.trim()}</span>
              <br />
              <Text sx={{ color: "text.disabled" }}>{loc.country}</Text>
            </MapLink>
          );
        } else {
          return (
            <MapLink sx={{ textWrap: "balance" }} to={AppRoutes.Explore.path + "?id=" + data.id}>
              {data.meta?.location?.name?.trim() + ", " + data.meta?.location.country}
            </MapLink>
          );
        }
      },
    },
    {
      id: "trust",
      label: "Trust",
      render: (data: any) => {
        // Complaints and challenged deeds both point at the *verifier* under review, not the
        // holder: the EFT hasn't moved yet on a challenged settlement (ownerAddress is still the
        // minter until FINALISED), so the default branch below would render a bare "PENDING".
        // A pre-mint challenge is the same question one stage earlier — and there is no etNft at
        // all yet, so the default branch would read `undefined === undefined` and render "PENDING"
        // for every row. acceptedBy is preferred over the trust relation: it is the verifier the
        // chain actually bound to the request, which is whose score is being disputed.
        // An untaken request has no verifier by definition — that is why it is refundable.
        if (data?.isUntakenRequest) {
          return (
            <Text numeric contrast medium sx={{ color: "GrayText" }}>
              UNASSIGNED
            </Text>
          );
        }
        if (data?.isPreMintChallenged && (data?.acceptedBy || data?.trust?.address)) {
          return (
            <AddressLink
              sx={{ textDecoration: "underline" }}
              type="trust"
              address={data?.acceptedBy || data?.trust?.address || ""}
            />
          );
        }
        if ((data?.isComplaint || data?.isChallenged) && data?.trust?.address) {
          return <AddressLink sx={{ textDecoration: "underline" }} type="trust" address={data?.trust?.address || ""} />;
        }
        const { etNft } = data;
        if (etNft?.ownerAddress === etNft?.minterAddress) {
          return (
            <Text numeric contrast medium sx={{ color: "GrayText" }}>
              PENDING
            </Text>
          );
        } else {
          return <AddressLink sx={{ textDecoration: "underline" }} type="user" address={etNft?.ownerAddress || ""} />;
        }
      },
    },
    {
      id: "status",
      label: "Status",
      style: {
        width: "185px",
      },
      render: (data: any) => {
        // Ahead of resolveStandardStatus, which would read the land's VERIFICATION_REQUIRED as an
        // ordinary "Verification" in progress — nobody is verifying it, and the guardian's fee is
        // waiting on this admin. It pulses once the refund is actually open.
        if (data?.isUntakenRequest) {
          const due = untakenRequests.isRefundable(data);
          const fee = formatValue(data.untaken.feeAmount as bigint, true, 2, CURRENCY_NAME);
          return (
            <Text medium normal sx={{ flexDirection: "column", gap: 0.5 }}>
              <Text numeric contrast medium sx={{ color: due ? "primary.error" : undefined }}>
                {due && <PulseCircle warning />}
                Untaken request
              </Text>
              <Text sx={{ color: "text.disabled" }}>
                {due
                  ? `${fee} refundable`
                  : `${fee} refundable ${moment(data.untaken.refundableAt).format("D MMM, HH:mm")}`}
              </Text>
            </Text>
          );
        }

        if (data?.isComplaint) {
          return (
            <Text medium normal sx={{ flexDirection: "column", gap: 0.5 }}>
              <Text numeric contrast medium>
                Complaint
              </Text>
              <Text sx={{ color: "text.disabled", textTransform: "capitalize" }}>{data?.filerType || "-"}</Text>
            </Text>
          );
        }

        // Checked before resolveStandardStatus, which would otherwise report the auction result
        // ("Sold") and hide the fact that the settlement behind it is frozen.
        if (data?.isChallenged) {
          return (
            <Text medium normal sx={{ flexDirection: "column", gap: 0.5 }}>
              <Text numeric contrast medium sx={{ color: "primary.error" }}>
                <PulseCircle warning />
                Deed challenged
              </Text>
              <Text sx={{ color: "text.disabled" }}>
                {data?.challengedAt ? formatRelativeTime(data.challengedAt) : "Awaiting judgement"}
              </Text>
            </Text>
          );
        }

        // Same reason as isChallenged above: the settlement here is FINALISED, so
        // resolveStandardStatus would cheerfully report "Sold" and bury the fact that the
        // owner's rewards are frozen pending this admin's own verdict.
        if (data?.isTermChallenged) {
          // Two independent booleans, never conflated (V10_Challenge_Paths §0): `upheld` is about
          // the verifier, `inBreach` about the covenant. "Frozen" follows inBreach alone.
          const upheld = data?.termChallengeUpheld;
          const inBreach = data?.termChallengeInBreach;
          const determined = upheld !== null && upheld !== undefined;
          // "Rewards frozen" is EcoBank.dripFrozen as read, not inferred from inBreach: the freeze
          // clears at releaseAfterReVerification while the finding stays on record.
          const frozen = !!data?.termChallengeFrozen;
          const label = data?.reseatRequired
            ? "Reseat required"
            : !determined
            ? "Verification challenged"
            : upheld
            ? frozen
              ? "Upheld — in breach, rewards frozen"
              : inBreach
              ? "Upheld — in breach, re-verified"
              : "Upheld — verifier flagged"
            : frozen
            ? "Dismissed — in breach, rewards frozen"
            : "Dismissed";
          const detail = data?.reseatRequired
            ? !data?.seatedVerifier
              ? "Reassign the covenant"
              : data?.seatedVerifierDismissed
              ? "Verifier dismissed — reassign the covenant"
              : "Dismiss the seated verifier, then reassign"
            : frozen
            ? "Awaiting re-verification"
            : data?.termChallengedAt
            ? formatRelativeTime(data.termChallengedAt)
            : "Awaiting determination";
          return (
            <Text medium normal sx={{ flexDirection: "column", gap: 0.5 }}>
              <Text numeric contrast medium sx={{ color: "primary.error" }}>
                <PulseCircle warning />
                {label}
              </Text>
              <Text sx={{ color: "text.disabled" }}>{detail}</Text>
            </Text>
          );
        }

        // Checked before resolveStandardStatus for the same reason as the two above: the row's
        // eco-token status is APPROVED, which that helper reports as a perfectly healthy
        // "Verified" — burying the fact that the guardian's mint is blocked on this admin's
        // verdict.
        if (data?.isPreMintChallenged) {
          return (
            <Text medium normal sx={{ flexDirection: "column", gap: 0.5 }}>
              <Text numeric contrast medium sx={{ color: "primary.error" }}>
                <PulseCircle warning />
                Score challenged
              </Text>
              <Text sx={{ color: "text.disabled" }}>
                {data?.challengedAt ? formatRelativeTime(data.challengedAt) : "Awaiting judgement"}
              </Text>
            </Text>
          );
        }

        const { status, etNft, meta } = data as LandToken;
        const standardized = resolveStandardStatus({ status, etNft, meta }, { role: "admin" });
        if (standardized) {
          return (
            <Text numeric capital contrast sx={{ color: standardized.color }}>
              {standardized.showPulse && (
                <PulseCircle
                  warning={!!standardized.pulseWarning}
                  sold={!!standardized.pulseSold && !standardized.pulseWarning}
                />
              )}
              {standardized.label}
            </Text>
          );
        }

        let text = "Verification";
        let color = "primary.main";
        let pulseSuccess = false;
        let pulseWarning = false;
        let showPulse = false;
        const isVerification = onVerification(status) || status === EcoTokenStatus.VERIFICATION_REQUIRED;
        const isReassignment = onReassignment(status);
        if (isVerification) {
          showPulse = false;
          pulseWarning = false;
          text = "Verification";
          color = "primary.main";
        } else if (isReassignment) {
          text = "Reassignment";
          color = "primary.error";
        } else if (status === EcoTokenStatus.APPROVED) {
          text = "Verified";
          color = "primary.main";
        } else if (status === EcoTokenStatus.VERIFICATION_FAILED) {
          text = "Rejected";
          color = "warning.main";
        } else if (etNft?.id && etNft?.status === EcoTokenStatus.VERIFIED) {
          text = "Verified";
          color = "primary.main";
        } else if (etNft?.id && etNft?.status === "auction") {
          showPulse = true;
          pulseWarning = false;
          text = "Live auction";
          color = "action.pulse";
        } else if (etNft?.easementActivated && etNft.easementActivated.active) {
          const start = moment(etNft?.easementActivated.contractStart);
          const duration = meta?.contractPeriod || 3;
          // TODO change to years
          if (start.add(duration, "days").isAfter(moment())) {
            pulseSuccess = true;
            showPulse = true;
            text = "Active";
            color = "action.pulse";
          } else {
            showPulse = false;

            const total = formatValue(etNft.easementActivated.treeTotal, false);
            const claimed = formatValue(etNft.easementActivated.rewardClaimed, false);
            if (total && total - claimed > 0) {
              text = "Mint Available";
            } else {
              text = "Expired";
            }
            color = "text.primary";
          }
        }
        return (
          <Text numeric capital contrast sx={{ color: color }}>
            {showPulse && <PulseCircle warning={pulseWarning} sold={pulseSuccess && !pulseWarning} />}
            {text}
          </Text>
        );
      },
    },
    {
      id: "actions",
      label: "Actions",
      style: {
        width: "280px",
      },
      // One action per row, and never Inspect: the Name and Land cells open the land page (see
      // ecoFuturesLandId), so a button that does the same would only crowd the one that acts.
      // A standing verification challenge (pre-mint, or a live covenant-term one) gets Judge, which
      // opens the land's verification page in judge mode. Rows whose remedy lives on the land
      // page itself (a deed challenge in its SettlementPanel, a covenant-term row with no live
      // challenge left) carry no button. They are deliberately denied the ellipsis menu too:
      // reassigning, unblocking or cancelling an EFT fights the state machine rather than
      // resolving the challenge, which only a panel determination can (Core reverts
      // ChallengeIsOpen on all three while one stands).
      render: (data, _index) => (
        <Row sx={{ gap: "12px", justifyContent: "start" }}>
          {data?.isUntakenRequest ? (
            // Refund is the whole remedy — useUntakenRequests owns the dry run, the transport
            // (relay for a Trust Admin, own wallet for a GTA) and the revert copy, which lands
            // under the button.
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
              <Tooltip
                {...tooltipTransitionProps}
                enterDelay={TOOLTIP_DELAY_MS}
                title={
                  !untakenRequests.isRefundable(data)
                    ? "The verifier acceptance window has not passed yet"
                    : untakenRequests.viewerIsGta
                    ? "Returns the verification fee to the guardian. As a GTA you send this from your own wallet and pay the gas."
                    : "Returns the verification fee to the guardian. Signed with your wallet — no gas."
                }
              >
                {/* A disabled button fires no pointer events, so the tooltip hangs off a wrapper. */}
                <span>
                  <TableActionButton
                    size="small"
                    color="primary"
                    className={untakenRequests.busyId === data.untaken.requestId ? "is-busy" : undefined}
                    aria-busy={untakenRequests.busyId === data.untaken.requestId}
                    disabled={!untakenRequests.isRefundable(data) || untakenRequests.busyId !== null}
                    variant="contained"
                    sx={{ textTransform: "none" }}
                    onClick={() => untakenRequests.refund(data)}
                  >
                    <BusyLabel busy={untakenRequests.busyId === data.untaken.requestId}>Refund guardian</BusyLabel>
                  </TableActionButton>
                </span>
              </Tooltip>
              {untakenRequests.error?.requestId === data.untaken.requestId && (
                // Keyed on the message, so a second, different refusal replays the swap.
                <Text
                  key={untakenRequests.error?.message}
                  sx={{ ...swapInSx(), color: "error.main", fontSize: "13px", maxWidth: 280 }}
                >
                  {untakenRequests.error?.message}
                </Text>
              )}
            </Box>
          ) : data?.isPreMintChallenged ? (
            // Judged on the land's verification page (openVerificationToJudge), where the record
            // under review is — the land page has no panel to hang it on while nothing is minted.
            //
            //   Judge (Trust Admin / GTA seat)  V10.1: Governance.judgePreMint(requestId, ground,
            //     upheld, signatures). A drawn panel (score) or single checker (documents) signs
            //     a real verdict; upheld-on-score reassigns to the challenger, upheld-on-documents
            //     fails the request, dismissed flags the challenger. See
            //     JudgeVerificationChallengeDialog, which the page opens prefilled.
            //
            // The manual Reassign route (leave the challenge standing, hand the request to a new
            // verifier) is no longer offered from this row: judgePreMint's upheld-on-score verdict
            // already reassigns, and one action per row keeps the verdict the thing to do.
            //
            // Not gated on role here: the contract rejects the wrong caller, and this tab is
            // already admin-only. Gating locally would mean duplicating the org-graph's notion of
            // "is the GTA" in a third place.
            <TableActionButton
              size="small"
              color="primary"
              disabled={isLoading || !data?.requestId}
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={() => openVerificationToJudge(data.id)}
            >
              Judge
            </TableActionButton>
          ) : data?.isTermChallenged && data?.termChallengeLive && data?.landId ? (
            // A live covenant-term challenge (EcoChallenge.recordOutcome), judged the same way.
            // Needs the resolved land id — a row that fell back to the NFT id has no page to open.
            <TableActionButton
              size="small"
              color="primary"
              disabled={isLoading}
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={() => openVerificationToJudge(data.landId)}
            >
              Judge
            </TableActionButton>
          ) : data?.reseatRequired ? (
            // An upheld FIELD finding (V10.1): the seat must move to the challenger, in the
            // contract's forced order — dismiss the seated verifier (Admin.dismissVerifier, which
            // needs the flag bar met; the panel's finding meets it), then reassign the covenant
            // (Core.addVerifierToEasement, which refuses while the verifier is neither dismissed
            // nor overdue), then the new verifier re-verifies, which is what unfreezes the drip.
            // The row offers only the step that is next (seatedVerifierDismissed, read from
            // chain); both existing dialogs are reused.
            data?.seatedVerifier && !data?.seatedVerifierDismissed ? (
              <TableActionButton
                size="small"
                color="error"
                disabled={isLoading}
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={() => blockTrustee(data.seatedVerifier)}
              >
                Dismiss verifier
              </TableActionButton>
            ) : (
              <TableActionButton
                size="small"
                color="primary"
                disabled={isLoading}
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={() => handleReassignOpen(data)}
              >
                Reassign
              </TableActionButton>
            )
          ) : data?.isChallenged || data?.isTermChallenged ? null : data?.isComplaint ? (
            // Not navigation: the complaint's filing (description, files) and its accept/reject
            // live in ComplaintModal, which the land page does not show.
            <TableActionButton
              size="small"
              color="primary"
              disabled={isLoading}
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={() => handleComplaintInspectOpen(data)}
            >
              Review
            </TableActionButton>
          ) : (
            <>
              <TableActionButton
                size="small"
                color="primary"
                disabled={isLoading}
                variant="outlined"
                sx={{ textTransform: "none" }}
                onClick={(event) => handleClick(event, data)}
              >
                ...
              </TableActionButton>
              <Menu
                id={`menu-${data.id}`}
                anchorEl={anchorEl}
                open={Boolean(anchorEl) && selectedMenuId === data.id}
                onClose={handleClose}
                // The transitions-dev dropdown the notifications popover uses: grows out of
                // the button's corner, closes shorter and quieter (see PanelTransition).
                TransitionComponent={PanelTransition}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                MenuListProps={{
                  sx: {
                    "& .MuiMenuItem-root": {
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    },
                  },
                }}
              >
                <MenuItem onClick={() => handleReassignOpen(data)}>
                  <AssignmentIndOutlinedIcon sx={{ marginRight: 1 }} /> Reassign
                </MenuItem>
                <MenuItem onClick={() => handleUnblockOpen(data)}>
                  <LockOpenIcon sx={{ marginRight: 1 }} /> Unblock
                </MenuItem>
                <MenuItem onClick={() => handleCancelOpen(data)}>
                  <CancelOutlinedIcon sx={{ marginRight: 1 }} /> Cancel EFT
                </MenuItem>
                <MenuItem onClick={() => handleReleaseFundsOpen(data)}>
                  <NewReleasesOutlinedIcon sx={{ marginRight: 1 }} /> Release Funds
                </MenuItem>
              </Menu>
            </>
          )}
        </Row>
      ),
    },
  ];

  const combinedEcofuturesData = React.useMemo(() => {
    const normalizedComplaints = (complaintsData || []).map((complaint: any) => ({
      ...complaint,
      isComplaint: true,
      description: complaint?.description,
      fileUrls: Array.isArray(complaint?.fileUrls) ? complaint.fileUrls : [],
      filerType: complaint?.filerType,
      content: complaint?.content ?? complaint?.ecoToken?.content ?? null,
      meta: complaint?.meta ?? complaint?.ecoToken?.meta ?? null,
      trust: complaint?.trust ?? complaint?.ecoToken?.trust ?? null,
    }));

    // Challenged deeds sit at the top: settlement is held and the escrow with it until the drawn
    // checker's determination is recorded, so they are the most time-sensitive thing on this tab.
    // Verification-stage challenges follow — a frozen reward drip awaiting a panel (or a reseat)
    // rather than a whole settlement, so a step less urgent. Pre-mint challenges come after
    // both: they block a mint, and no money is held anywhere while they stand. Untaken requests
    // follow them — a guardian's fee sits in escrow until someone refunds it.
    return [
      ...(challengedData || []),
      ...(termChallengedData || []),
      ...(preMintChallengedData || []),
      ...untakenRequests.rows,
      ...(unverifiedEFData || []),
      ...normalizedComplaints,
    ];
  }, [
    challengedData,
    termChallengedData,
    preMintChallengedData,
    untakenRequests.rows,
    unverifiedEFData,
    complaintsData,
  ]);

  useEffect(() => {
    // Wait for cache to finish loading before fetching data
    if (profileCache.isLoading) {
      console.log("Portal: Cache is loading, waiting...");
      return;
    }
    fetchData();
    if (isGlobalTrustAdmin && activeTab === "admins") {
      fetchAdmins();
    }
  }, [profileCache.isLoading, profileCache.lastFetched, activeTab]);

  // A GTA seated straight into the Governance registry has no trust-admin invite or KYC, so
  // /admin/trustAdmins/kyc-verified never returns it. Build its Admins row from the public wallet
  // profile, plus its latest transaction for the "Last Txn" column.
  const fetchGtaRows = (addresses: string[]) =>
    Promise.all(
      addresses.map(async (address) => {
        const [profile, transactions] = await Promise.all([
          axios
            .get(ApiRoutes.user.checkWallet(address))
            .then((res) => res.data?.wallet ?? null)
            .catch(() => null),
          axios
            .get(`${ApiRoutes.ecoBank.transactions.byAddress(address)}&limit=1&offset=0`)
            .then((res) => res.data)
            .catch(() => []),
        ]);
        return { ...(profile ?? {}), address, lastTxn: Array.isArray(transactions) ? transactions[0] : undefined };
      })
    );

  const fetchAdmins = async () => {
    setLoading(true);
    try {
      const cachedAdmins = getCachedData("adminTrustAdmins");
      const cachedOrganizations = getCachedData("adminOrganizations");
      const [response, organizations, gtaRegistry] = await Promise.all([
        cachedAdmins ?? axios.get(ApiRoutes.admin.trustAdminsKycVerified).then((res) => res.data),
        cachedOrganizations ?? axios.get(ApiRoutes.admin.organizations).then((res) => res.data),
        // Best-effort: without the registry the tab still lists the trust admins.
        axios
          .get(ApiRoutes.orgGraph.gtas)
          .then((res) => res.data)
          .catch(() => null),
      ]);
      console.log("Portal: admins endpoint response data", response);
      const trustAdminRows = Array.isArray(response) ? response : Array.isArray(response?.data) ? response.data : [];

      // The Admins tab is GTA-only, so the viewer is always a GTA: list the other GTAs (registry
      // order, first) ahead of the trust admins, and leave the viewer out of both.
      const viewerAddress = user?.address?.toLowerCase();
      const gtaAddresses: string[] = (Array.isArray(gtaRegistry?.gtas) ? gtaRegistry.gtas : [])
        .map((gta: any) => gta?.walletAddress?.toLowerCase())
        .filter((address: string | undefined) => Boolean(address) && address !== viewerAddress);
      const gtaAddressSet = new Set(gtaAddresses);
      const trustAdminByAddress = new Map<string, any>();
      trustAdminRows.forEach((row: any) => {
        if (row?.address) trustAdminByAddress.set(row.address.toLowerCase(), row);
      });
      // A GTA that is also on the trust-admin list keeps that row (it carries the verified count).
      const fetchedGtaRows = await fetchGtaRows(gtaAddresses.filter((address) => !trustAdminByAddress.has(address)));
      const fetchedGtaByAddress = new Map<string, any>(fetchedGtaRows.map((row) => [row.address, row]));
      const adminRows = [
        ...gtaAddresses.map((address) => ({
          ...(trustAdminByAddress.get(address) ?? fetchedGtaByAddress.get(address)),
          isGTA: true,
        })),
        ...trustAdminRows.filter((row: any) => {
          const address = row?.address?.toLowerCase();
          return address !== viewerAddress && !gtaAddressSet.has(address);
        }),
      ];
      const organizationsList = Array.isArray(organizations)
        ? organizations
        : Array.isArray(organizations?.data)
        ? organizations.data
        : [];

      // GET /admin/trustAdmins/kyc-verified doesn't embed org data — join by wallet
      // address against GET /admin/organizations (mirrors the trusteeData join in
      // fetchData() below, which flat-maps the same response's secondaryWallets).
      const orgByAddress = new Map<string, any>();
      organizationsList.forEach((org: any) => {
        (Array.isArray(org?.secondaryWallets) ? org.secondaryWallets : []).forEach((member: any) => {
          if (member?.address) {
            orgByAddress.set(member.address.toLowerCase(), org);
          }
        });
      });

      const enrichedRows = adminRows.map((row: any) => {
        const org = row?.address ? orgByAddress.get(row.address.toLowerCase()) : undefined;
        if (!org) return row;
        return {
          ...row,
          orgID: org.id,
          orgName: org.name,
          orgVerified: org.verified,
          orgAddress: org.address,
          orgCountry: org.country,
          orgWebsite: org.website,
          orgProofOfAddress: org.proofOfAddress,
          orgType: org.type,
          orgPhone: org.phone,
          orgEmail: org.email,
          createdByTrustAdmin: org.createdByTrustAdmin,
          orgVerifiedLands: Array.isArray(org?.verifiedLands) ? org.verifiedLands : [],
        };
      });

      setAdminsData(normalizeTrusteeLikeRows(enrichedRows));
    } catch (e: any) {
      console.log({ e });
    } finally {
      setLoading(false);
      setAdminsLoading(false);
    }
  };

  useEffect(() => {
    console.log({ trusteeData });
    setUnverifiedData(
      trusteeData.filter((trustee) => trustee?.trusteeStatus === "accepted" || trustee?.trustStatus === "accepted")
    );
    const filteredData = trusteeData.filter((trustee) => trustee?.trusteeStatus === "verified");
    const sortedData = filteredData.sort((a, b) => {
      // Active status comes first, blocked status comes last
      if (a.status === "active" && b.status !== "active") return -1;
      if (a.status !== "active" && b.status === "active") return 1;
      if (a.status === "blocked" && b.status !== "blocked") return 1;
      if (a.status !== "blocked" && b.status === "blocked") return -1;
      return 0;
    });
    setVerifiedData(sortedData);
  }, [trusteeData]);

  const fetchData = async () => {
    setAnchorEl(null);
    setApproveOpen(false);
    setReassignOpen(false);
    setLoading(true);
    setTrusteeData([]);
    try {
      const fetchComplaints = async () => {
        try {
          const cachedComplaints = getCachedData("complaintsData");
          const complaintsResponse =
            cachedComplaints ?? (await axios.get(ApiRoutes.trust.complaints.root).then((res) => res.data));
          const complaintsList = Array.isArray(complaintsResponse)
            ? complaintsResponse
            : complaintsResponse?.data ?? [];
          const pendingComplaints = normalizeComplaintRows(complaintsList).filter(
            (complaint: any) => String(complaint?.status ?? "").toLowerCase() === "pending"
          );
          setComplaintsData(pendingComplaints);
        } catch (error) {
          console.error("Portal: Failed to fetch complaints", error);
          setComplaintsData([]);
        }
      };

      // Challenged deeds are deliberately not routed through the profile cache: the row only
      // exists between a challenge and its judgement, and a stale one points an admin at a
      // settlement that has already resumed. Admin-only endpoint, same as complaints — a 403
      // for a country-scoped admin just empties the section rather than breaking the tab.
      const fetchChallengedSettlements = async () => {
        try {
          const response = await axios
            .get(`${ApiRoutes.settlement.list}?state=challenged&limit=${CHALLENGED_ROW_LIMIT}`)
            .then((res) => res.data);
          const items = Array.isArray(response?.items) ? response.items : [];

          // Join each settlement to its land. A row whose land can't be read is still worth
          // showing — the admin needs to know a deed is frozen — so it degrades to the bare
          // settlement rather than being dropped.
          const rows = await Promise.all(
            items.map(async (nft: any) => {
              // `base` is spread *after* the land so the settlement wins on `challengedAt`:
              // eco_token carries a column of that name too, and it means something else
              // entirely (the pre-mint verification challenge, not this deed).
              const base = {
                // Also the row key and the Inspect target when the land read below fails.
                id: nft?.tokenId,
                isChallenged: true,
                etNft: nft,
                challengedAt: nft?.challengedAt ?? null,
                deedHash: nft?.deedHash ?? null,
              };
              try {
                const land = await axios
                  .get(ApiRoutes.token.details(String(nft?.tokenId)))
                  .then((res) => res.data);
                return land ? { ...land, ...base, etNft: { ...(land.etNft ?? {}), ...nft } } : base;
              } catch (error) {
                console.error("Portal: Failed to load land for challenged settlement", nft?.id, error);
                return base;
              }
            })
          );
          console.log("Portal: challenged settlements table data", rows);
          setChallengedData(rows);
        } catch (error) {
          console.error("Portal: Failed to fetch challenged settlements", error);
          setChallengedData([]);
        }
      };

      // Covenant-term challenges, on the same terms as the deed challenges above (uncached,
      // admin-only, degrades to empty on 403). A separate endpoint rather than another `state`
      // filter because there is no settlement state for this — the settlement is FINALISED the
      // whole time and what is frozen is the owner's TREE drip.
      //
      // V10.1: the queue is every covenant with a live EcoChallenge challenge, or a determined one
      // whose consequence still stands (frozen, halted, a better record owed, a seat transfer
      // pending, a settlement held). The spec has GET /settlement/term-challenges derive that set
      // server-side and put `review` — the same shape hooks/useCovenantReviewState reads from chain —
      // on every row. The backend at HEAD does neither (docs/v10/BACKEND_V10_1_BRANCH_AUDIT.md,
      // item 3): it still runs the V9 frozen-drip query, so its rows are raw EtNft (`id` = NFT id,
      // `tokenId` = land FK, no `review`) for FROZEN tokens only. A live OPEN / RESPONDED / SEATED challenge,
      // an upheld FIELD finding waiting on a reseat (inBreach=false — never freezes,
      // EcoChallenge.sol:805-812) and an upheld EVIDENCE finding awaiting a better record are all
      // missing from it. So the row SET is completed from chain here: one capped scan back from
      // nextChallengeId (listRecentChallengeSubjects) yields every recently challenged token, that
      // is unioned with the REST rows (dedupe on the NFT id; the REST row wins for `etNft` data, the
      // chain-only rows carry a stub), every row without `review` is read from chain, and only rows
      // whose review says something still stands are kept. When the backend ships the derived set,
      // its rows arrive with `review` and simply take precedence — nothing here has to change.
      //
      // The one thing the Holder must be told here is a pending reseat: the panel records two
      // booleans (upheld governs the verifier, inBreach governs the covenant) and an upheld FIELD
      // finding moves the seat, in the forced order dismiss → reseat → re-verify → unfreeze
      // (Core.addVerifierToEasement refuses until the seated verifier is dismissed or overdue).
      // `reseatRequired` is true only while the dismissed verifier is STILL the covenant's seated
      // one, so the row clears itself the moment the reseat lands.
      const fetchTermChallenges = async () => {
        try {
          const response = await axios
            .get(`${ApiRoutes.settlement.termChallenges}?limit=${CHALLENGED_ROW_LIMIT}`)
            .then((res) => res.data);
          const items = Array.isArray(response?.items) ? response.items : [];

          // Two ids per row, never conflated. The on-chain NFT id (EtNft.id — EcoChallenge's
          // `subject`, what every chain read takes) keys the union; the eco_token id (EtNft.tokenId,
          // the FK the land join and landDetailLink take — see the deed-challenge note above) is
          // the row's `id`. A raw EtNft row carries both (`{ id: 2, tokenId: 388 }` on the live
          // mirror); the settlement *view* calls the NFT id `tokenId` instead, so `tokenId` is
          // only trusted as the land FK when it sits beside an `id`. A chain-only subject has only
          // the NFT id, and Core.getEasement(nftId).internalTokenId is the chain's copy of the land
          // id — the backend sets EtNft.tokenId from exactly that field at mint.
          //
          // Union: REST rows first (already limited server-side), then chain subjects newest-
          // challenge first; a REST row wins on collision. A failed scan is an empty addition, not
          // an error — the REST rows still render.
          const byNft = new Map<string, { nft: any; fromRest: boolean }>();
          items.forEach((nft: any) => {
            const nftId = nft?.id ?? nft?.tokenId;
            if (nftId !== undefined && nftId !== null) {
              byNft.set(String(nftId), { nft, fromRest: true });
            }
          });
          let chainSubjects: bigint[] = [];
          try {
            chainSubjects = await listRecentChallengeSubjects();
          } catch (error) {
            console.warn("Portal: chain scan for term challenges failed; showing the REST rows only", error);
          }
          chainSubjects.forEach((subject) => {
            const key = subject.toString();
            if (!byNft.has(key)) {
              // A stub in the raw row's shape (`id` = NFT id); `review` is read from chain below
              // and the land join fills in the rest.
              byNft.set(key, { nft: { id: key }, fromRest: false });
            }
          });
          console.log(
            `Portal: term challenges — REST ${items.length}, chain ${chainSubjects.length}, union ${byNft.size}`
          );

          const candidates = await Promise.all(
            Array.from(byNft.entries()).map(async ([nftId, { nft, fromRest }]) => {
              let review = nft?.review ?? null;
              if (!review) {
                try {
                  const state = await fetchCovenantReviewState(nftId);
                  review = {
                    dripFrozen: state.frozen,
                    releasesHalted: state.releasesHalted,
                    awaitingBetterRecord: state.awaitingBetterRecord,
                    reseatRequired: state.reseatRequired,
                    heldSettlement: state.heldSettlement,
                    verifier: state.verifier,
                    challenge: state.challenge
                      ? { challengeId: Number(state.challenge.challengeId), challenger: state.challenge.challenger, openedAt: state.challenge.openedAt }
                      : null,
                    lastDetermined: state.lastDetermined
                      ? {
                          challengeId: Number(state.lastDetermined.challengeId),
                          challenger: state.lastDetermined.challenger,
                          verifier: state.lastDetermined.verifier,
                          upheld: state.lastDetermined.upheld,
                          inBreach: state.lastDetermined.inBreach,
                          kind: state.lastDetermined.kind,
                          openedAt: state.lastDetermined.openedAt,
                        }
                      : null,
                  };
                } catch (error) {
                  console.warn("Portal: chain read for term challenge failed; using the mirror", nftId, error);
                }
              }
              // Only a row with something still standing belongs in the queue: a live challenge,
              // or a determined one whose consequence has not cleared. A chain-only subject whose
              // challenge lapsed or resolved cleanly is dropped here; a REST row is kept even when
              // its chain read failed (`review` null) because the mirror says the drip is frozen.
              const stands = review
                ? !!review.challenge ||
                  !!review.dripFrozen ||
                  !!review.reseatRequired ||
                  !!review.awaitingBetterRecord ||
                  !!review.heldSettlement
                : fromRest;
              if (!stands) {
                return null;
              }
              // The land id: the mirror's FK when it gave us the row, else the easement's internal
              // reference from chain (empty string for an id that was never minted).
              let landId: string | null =
                fromRest && nft?.id !== undefined && nft?.id !== null && nft?.tokenId !== undefined && nft?.tokenId !== null
                  ? String(nft.tokenId)
                  : null;
              if (!landId) {
                try {
                  const core = getReadOnlyContract("ecofutures-core");
                  const internal = core ? String((await core.getEasement(BigInt(nftId))).internalTokenId ?? "") : "";
                  landId = internal || null;
                } catch (error) {
                  console.warn("Portal: easement read for term challenge failed; no land join", nftId, error);
                }
              }
              const live = review?.challenge ?? null;
              const determined = review?.lastDetermined ?? null;
              const seatedVerifier = review?.verifier ?? determined?.verifier ?? null;
              // A reseat is two steps in a forced order — dismiss the seated verifier, then
              // reassign — and the row offers only the next one, so it needs to know which that
              // is. Admin.isVerifierDismissed is the contract's own answer; on a failed read the
              // row falls back to the first step, which the contract will refuse by name if the
              // dismissal has in fact landed.
              let seatedVerifierDismissed = false;
              if (review?.reseatRequired && seatedVerifier) {
                try {
                  const admin = getReadOnlyContract("ecofutures-admin");
                  seatedVerifierDismissed = admin ? Boolean(await admin.isVerifierDismissed(seatedVerifier)) : false;
                } catch (error) {
                  console.warn("Portal: dismissal read for reseat failed; offering dismiss", nftId, error);
                }
              }
              // Spread after the land for the same reason as above — eco_token has its own
              // unrelated challenge columns and must not win here.
              const base = {
                // The row key and the Inspect target (landDetailLink wants the land id). Falls
                // back to the NFT id only when the land could not be resolved at all.
                id: landId ?? nftId,
                // The land id alone, null when unresolved — what the Judge button opens.
                landId,
                isTermChallenged: true,
                etNft: nft,
                termChallengedAt: live?.openedAt ?? determined?.openedAt ?? nft?.termChallengedAt ?? null,
                termChallengeUpheld: live ? null : determined?.upheld ?? nft?.termChallengeUpheld ?? null,
                termChallengeInBreach: live ? null : determined?.inBreach ?? null,
                termChallengeLive: !!live,
                termChallengeFrozen: !!review?.dripFrozen,
                reseatRequired: !!review?.reseatRequired,
                seatedVerifier,
                seatedVerifierDismissed,
                termChallenger: live?.challenger ?? determined?.challenger ?? null,
              };
              if (!landId) {
                return base;
              }
              try {
                const land = await axios
                  .get(ApiRoutes.token.details(landId))
                  .then((res) => res.data);
                return land ? { ...land, ...base, etNft: { ...(land.etNft ?? {}), ...nft } } : base;
              } catch (error) {
                console.error("Portal: Failed to load land for term challenge", nftId, error);
                return base;
              }
            })
          );
          const rows = candidates.filter((row) => row !== null);
          console.log("Portal: term challenges table data", rows);
          setTermChallengedData(rows);
        } catch (error) {
          console.error("Portal: Failed to fetch term challenges", error);
          setTermChallengedData([]);
        }
      };

      // Pre-mint challenges, on the same terms as the two above (uncached, admin-only, degrades
      // to empty on 403). No per-row land join is needed here, unlike the settlement queues: the
      // rows ARE eco-tokens, so the meta/trust/minter the table renders is already on them.
      const fetchPreMintChallenges = async () => {
        try {
          const response = await axios
            .get(`${ApiRoutes.trust.preMintChallenges}?limit=${CHALLENGED_ROW_LIMIT}`)
            .then((res) => res.data);
          const items = Array.isArray(response) ? response : response?.items ?? [];
          setPreMintChallengedData(
            items.map((token: any) => ({
              ...token,
              isPreMintChallenged: true,
            }))
          );
        } catch (error) {
          console.error("Portal: Failed to fetch pre-mint challenges", error);
          setPreMintChallengedData([]);
        }
      };

      // Try to get cached data first
      const cachedAdminOrganizations = getCachedData("adminOrganizations");
      const cachedUnverifiedTrusts = getCachedData("unverifiedTrusts");

      if (cachedAdminOrganizations && cachedUnverifiedTrusts) {
        console.log("Portal: Using cached admin data", { cachedAdminOrganizations, cachedUnverifiedTrusts });

        // Process cached organization data
        (cachedAdminOrganizations as any).map((item: any) => {
          (item.secondaryWallets as any).map((walletItem: any) => {
            const walletData = toApplicantRow(item, walletItem);
            console.log(walletData);
            setTrusteeData((prev: any) => {
              return [...prev, walletData];
            });
          });
        });

        setUnverifiedEFData(cachedUnverifiedTrusts);
        await Promise.all([
          fetchComplaints(),
          fetchChallengedSettlements(),
          fetchTermChallenges(),
          fetchPreMintChallenges(),
        ]);
        setLoading(false);
        return;
      }

      // Fallback to API calls if no cached data
      console.log("Portal: No cached data found, making API calls");
      const cachedComplaints = getCachedData("complaintsData");
      // Make both API calls in parallel
      const [response, unverified, complaintsResponse] = await Promise.all([
        axios.get(ApiRoutes.admin.organizations).then((res) => res.data),
        axios.get(ApiRoutes.trust.unverified).then((res) => res.data),
        cachedComplaints
          ? Promise.resolve(cachedComplaints)
          : axios.get(ApiRoutes.trust.complaints.root).then((res) => res.data),
        // Set their own state, so their slots in the tuple are deliberately unread — they are
        // here only to share the round-trip with the calls above.
        fetchChallengedSettlements(),
        fetchTermChallenges(),
        fetchPreMintChallenges(),
      ]);
      (response as any).map((item: any) => {
        console.log(item.name);
        (item.secondaryWallets as any).map((walletItem: any) => {
          const walletData = toApplicantRow(item, walletItem);
          console.log(walletData);
          setTrusteeData((prev: any) => {
            return [...prev, walletData];
          });
        });
      });
      setUnverifiedEFData(unverified);
      const complaintsList = Array.isArray(complaintsResponse) ? complaintsResponse : complaintsResponse?.data ?? [];
      const pendingComplaints = normalizeComplaintRows(complaintsList).filter(
        (complaint: any) => String(complaint?.status ?? "").toLowerCase() === "pending"
      );
      setComplaintsData(pendingComplaints);
    } catch (e: any) {
      console.log({ e });
    } finally {
      setLoading(false);
    }
  };

  // The Admins tab has its own table skeleton, so it doesn't need the page-level placeholder.
  if (isLoading && trusteeData && trusteeData.length === 0 && activeTab !== "admins") {
    return (
      <Container>
        <EmptyBox style={{ borderRadius: "20px", height: "60vh" }}>
          <span>🔎</span>
          <span>Data is loading...</span>
        </EmptyBox>
      </Container>
    );
  }

  // if (!isLoading && trusteeData.length === 0) {
  //     return (
  //         <Container>
  //             <EmptyBoxNew sx={{ backgroundColor: "transparent", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
  //                 <CircularProgress />
  //             </EmptyBoxNew>
  //         </Container>
  //     );
  // }

  return (
    <Container>
      <TableWithTabs sx={{ backgroundColor: "back.table", borderRadius: "20px" }}>
        <TabsRow
          sx={{
            p: "5px 24px 0px 24px",
            borderRadius: "20px 20px 0px 0px",
            marginBottom: "15px",
          }}
        >
          <FilterBlock
            sx={{
              "@media (min-width: 600px)": {
                display: "flex",
                overflowX: "auto",
                whiteSpace: "nowrap",
                paddingTop: "10px",
                width: "100%",
              },
              "@media (max-width: 599px)": {
                flexDirection: "row",
                paddingTop: "10px",
              },
            }}
          >
            {isGlobalTrustAdmin && (
              <ActionBtn
                className={activeTab === "admins" ? "active" : ""}
                disabled={activeTab === "admins"}
                variant={activeTab === "admins" ? "outlined" : "outlined"}
                size="medium"
                onClick={() => chooseTab("admins")}
              >
                Admins
              </ActionBtn>
            )}
            {!isGlobalTrustAdmin && (
              <>
                <ActionBtn
                  className={activeTab === "trustee" ? "active" : ""}
                  disabled={activeTab === "trustee"}
                  variant={activeTab === "trustee" ? "outlined" : "outlined"}
                  size="medium"
                  onClick={() => chooseTab("trustee")}
                >
                  Trustee
                </ActionBtn>
                <Badge badgeContent={unverifiedData.length} color="error">
                  <ActionBtn
                    className={activeTab === "newTrustee" ? "active" : ""}
                    disabled={activeTab === "newTrustee"}
                    variant={activeTab === "newTrustee" ? "outlined" : "outlined"}
                    size="medium"
                    onClick={() => chooseTab("newTrustee")}
                  >
                    New Trustee
                  </ActionBtn>
                </Badge>
              </>
            )}
            <Badge badgeContent={combinedEcofuturesData.length} color="error">
              <ActionBtn
                className={activeTab === "ecofutures" ? "active" : ""}
                disabled={activeTab === "ecofutures"}
                variant={activeTab === "ecofutures" ? "outlined" : "outlined"}
                size="medium"
                onClick={() => chooseTab("ecofutures")}
              >
                Ecofutures
              </ActionBtn>
            </Badge>
          </FilterBlock>
        </TabsRow>
        {!isGlobalTrustAdmin && activeTab === "trustee" && (
          <div style={{ height: "fit-content", minHeight: "50vh" }}>
            <TableComponent
              mobileTitle=""
              totalItems={trusteeData.length}
              title=""
              hideTitle={true}
              apiURL={""}
              schema={trusteeSchema}
              batch={5}
              customData={verifiedData}
              errorName="Trustee"
            />
          </div>
        )}
        {!isGlobalTrustAdmin && activeTab === "newTrustee" && (
          <div style={{ height: "fit-content", minHeight: "50vh" }}>
            <TableComponent
              mobileTitle=""
              totalItems={unverifiedData.length}
              title=""
              hideTitle={true}
              apiURL={""}
              schema={trusteeSchema}
              customData={unverifiedData}
              errorName="new Trustee"
            />
          </div>
        )}
        {activeTab === "ecofutures" && (
          <div style={{ height: "fit-content", minHeight: "50vh" }}>
            <TableComponent
              mobileTitle=""
              totalItems={combinedEcofuturesData.length}
              title=""
              hideTitle={true}
              apiURL={""}
              customData={combinedEcofuturesData}
              schema={ecoFuturesSchema}
              errorName="new Ecofutures"
            />
          </div>
        )}
        {isGlobalTrustAdmin && activeTab === "admins" && (
          <div style={{ height: "fit-content", minHeight: "50vh" }}>
            <TableComponent
              mobileTitle=""
              totalItems={adminsData.length}
              title=""
              hideTitle={true}
              apiURL={""}
              schema={adminSchema}
              customData={adminsData}
              isLoading={adminsLoading}
              skeletonRows={3}
              errorName="Admins"
            />
          </div>
        )}
      </TableWithTabs>

      {/* Inspect Pop up */}
      <OrgPopUp
        open={open}
        onClose={handleModalClose}
        orgData={{
          name: selectedUser?.orgName,
          phone: selectedUser?.orgPhone,
          country: selectedUser?.orgCountry,
          email: selectedUser?.orgEmail,
          address: selectedUser?.orgAddress,
          website: selectedUser?.orgWebsite,
          proofOfAddress: selectedUser?.orgProofOfAddress,
          secondaryWallets: trusteeData.filter((t) => t.orgID === selectedUser?.orgID),
          nativeKycStatus: selectedUser?.nativeKYCStatus ?? selectedUser?.nativeKycStatus,
        }}
        // orgLands matches the format UserWallet/Dashboard pass: the organization's
        // verified lands enriched to full LandToken objects (with content + etNft).
        orgLands={selectedOrgLands}
        singleTrustee={true}
        singleTrusteeData={selectedUser}
        initialTab={inspectModalView === 0 ? "singleTrustee" : "organization"}
      />

      {/* Approve Pop up */}

      <DialogInfo
        open={approveOpen}
        onClose={() => {
          setApproveOpen(false);
          setApproveError("");
        }}
        title={""}
      >
        <Wrapper
          sx={{
            p: 12,
            backgroundColor: "white",
            borderColor: "white",
          }}
        >
          <IconContainer>
            <CircularIcon>
              <InfoIconOutlined fontSize="large" color="primary" />
            </CircularIcon>
          </IconContainer>
          <InfoBody>
            <br />
            <p style={{ fontWeight: 600, color: "black", alignSelf: "center", fontSize: "26px" }}>
              Are you sure you want to approve {isTrustAdminApproval ? "Admin" : "Trustee"}?
            </p>
            <br />
            <p style={{ lineHeight: "1.5", textAlign: "center" }}>
              {selectedUser?.orgVerified === false
                ? `Please ensure you have performed thorough KYC on the organisation and ${
                    isTrustAdminApproval ? "admin" : "trust"
                  } you are approving.
                                This will give Trustee roles and responsibilities to the assigned wallet`
                : `Please ensure you have performed thorough KYC on the organisation and ${
                    isTrustAdminApproval ? "admin" : "trust"
                  } you are approving.
                                 This will give ${
                                   isTrustAdminApproval ? "Admin" : "Trustee"
                                 } roles and responsibilities to the assigned wallet`}
              {/* <br />
                            This will give Trustee roles and responsibilities to the assign wallet. */}
            </p>

            <p style={{ lineHeight: "1.5", textAlign: "center", color: "red" }}>
              {selectedUser?.profilePicture ? "" : "Profile picture is not available"}
            </p>
            {/* <p style={{ lineHeight: "1.5", textAlign: "center", color: "red" }} >
                            {selectedUser?.orgVerified === true ? "" : "Organization is not Verified"}
                        </p> */}
          </InfoBody>
          {approveError && (
            // Inline style: Wrapper's `p { color: #3d3d3d }` outranks Typography's colour prop.
            <Typography fontSize="14px" margin="12px 0" textAlign="center" style={{ color: theme.palette.error.main }}>
              {approveError}
            </Typography>
          )}
          <Grid
            container
            direction={"row"}
            alignItems="center"
            justifyContent={"space-around"}
            sx={{
              borderBottom: "1px solid GrayText",
              pb: 8,
              width: "100%",
            }}
          >
            <InfoButton
              onClick={() => {
                setApproveOpen(false);
                setApproveError("");
              }}
              style={{ borderColor: "#999999", backgroundColor: "#999999" }}
            >
              Cancel
            </InfoButton>
            <InfoButton
              onClick={() => {
                setApproveError("");
                // Verifier applications are only ever approved from the review, after the deed.
                isTrustAdminApproval ? handleVerifyAdmin(selectedUser) : openApplicantReview(selectedUser);
              }}
              color="primary"
              disabled={
                isLoading ||
                selectedUser?.profilePicture === null ||
                selectedUser?.proofOfId === null ||
                // Only the global Trust Admin may perform the on-chain Holder grant
                // (addHolder) — invited/accepted trust admins can surface in tabs other
                // admins can reach, so gate the confirm itself, not just the admins tab.
                (isTrustAdminApproval && !isGlobalTrustAdmin) ||
                // A pending Trust-Admin org must be approved separately before the
                // on-chain Holder grant can be requested here.
                (isTrustAdminApproval && selectedUser?.createdByTrustAdmin && selectedUser?.orgVerified === false)
              }
            >
              {isLoading ? "Loading" : "Approve applicant"}
            </InfoButton>
          </Grid>
          <br />
          <p style={{ paddingTop: "24px" }}>
            <a
              href="/help?blog=blog-article-3"
              style={{ marginRight: "4px" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Here
            </a>
            is an in-depth article covering thie role and responsibilities of the Trustee.
          </p>
        </Wrapper>
      </DialogInfo>

      {/* Dismiss trustee pop up — dismissVerifier needs an on-chain judgedFinding reason */}

      <DialogInfo
        open={!!dismissTarget}
        onClose={() => {
          if (!dismissLoading) {
            setDismissTarget(null);
          }
        }}
        title={""}
      >
        <Wrapper
          sx={{
            p: 12,
            backgroundColor: "white",
            borderColor: "white",
          }}
        >
          <IconContainer>
            <CircularIcon>
              <BlockOutlinedIcon fontSize="large" color="primary" />
            </CircularIcon>
          </IconContainer>
          <InfoBody>
            <br />
            <p style={{ fontWeight: 600, color: "black", alignSelf: "center", fontSize: "26px" }}>
              Dismiss this trustee?
            </p>
            <br />
            <p style={{ lineHeight: "1.5", textAlign: "center" }}>
              The reason below is recorded on-chain as the judged finding for this dismissal. You approve it with a
              wallet signature — no gas or BNB is needed.
            </p>
            <TextField
              fullWidth
              multiline
              minRows={2}
              label="Reason (judged finding)"
              value={dismissReason}
              onChange={(e) => setDismissReason(e.target.value)}
              disabled={dismissLoading}
              sx={{ mt: 4 }}
            />
            {dismissError && <p style={{ lineHeight: "1.5", textAlign: "center", color: "red" }}>{dismissError}</p>}
          </InfoBody>
          <Box sx={{ width: "100%", pb: 4, display: "flex", flexDirection: "column", gap: "10px" }}>
            {dismissLoading ? (
              <PopupProcessingButton disabled variant="contained" fullWidth style={{ width: "100%" }}>
                <CircularProgress size={20} sx={{ color: "white" }} />
              </PopupProcessingButton>
            ) : (
              <PopupActionButton
                onClick={confirmDismissVerifier}
                disabled={!dismissReason.trim()}
                variant="contained"
                fullWidth
                style={{ width: "100%" }}
              >
                Dismiss trustee
              </PopupActionButton>
            )}
            <PopupGhostButton onClick={() => setDismissTarget(null)} disabled={dismissLoading} fullWidth>
              Cancel
            </PopupGhostButton>
          </Box>
          <p style={{ fontSize: "13px", color: "#888", textAlign: "center" }}>
            Dismissal is signed with your wallet and submitted gaslessly — the reason becomes part of the on-chain
            record.
          </p>
        </Wrapper>
      </DialogInfo>

      {/* Release verification funds pop up — holder picks the on-chain resolution type */}

      <DialogInfo
        open={!!releaseTarget}
        onClose={() => {
          if (!releaseLoading) {
            setReleaseTarget(null);
          }
        }}
        title={""}
      >
        <Wrapper
          sx={{
            p: 12,
            backgroundColor: "white",
            borderColor: "white",
          }}
        >
          <IconContainer>
            <CircularIcon>
              <LockOpenIcon fontSize="large" color="primary" />
            </CircularIcon>
          </IconContainer>
          <InfoBody>
            <br />
            <p style={{ fontWeight: 600, color: "black", alignSelf: "center", fontSize: "26px" }}>
              Release verification funds
            </p>
            <br />
            <p style={{ lineHeight: "1.5", textAlign: "center" }}>
              Choose how the escrowed verification fee is resolved. You approve it with a wallet signature — no gas or
              BNB is needed.
            </p>
            <TextField
              select
              fullWidth
              label="Resolution"
              value={releaseResolutionType}
              onChange={(e) => setReleaseResolutionType(Number(e.target.value))}
              disabled={releaseLoading}
              sx={{ mt: 4 }}
            >
              <MenuItem value={3}>Pay the verifier (normal)</MenuItem>
              <MenuItem value={1}>Refund the guardian</MenuItem>
              <MenuItem value={2}>Bounty to a beneficiary</MenuItem>
              <MenuItem value={4}>Deed-check hold</MenuItem>
            </TextField>
            {(releaseResolutionType === 2 || releaseResolutionType === 4) && (
              <TextField
                fullWidth
                label="Beneficiary wallet address"
                value={releaseBeneficiary}
                onChange={(e) => setReleaseBeneficiary(e.target.value)}
                disabled={releaseLoading}
                sx={{ mt: 4 }}
              />
            )}
            {releaseError && <p style={{ lineHeight: "1.5", textAlign: "center", color: "red" }}>{releaseError}</p>}
          </InfoBody>
          <Box sx={{ width: "100%", pb: 4, display: "flex", flexDirection: "column", gap: "10px" }}>
            {releaseLoading ? (
              <PopupProcessingButton disabled variant="contained" fullWidth style={{ width: "100%" }}>
                <CircularProgress size={20} sx={{ color: "white" }} />
              </PopupProcessingButton>
            ) : (
              <PopupActionButton onClick={confirmReleaseFunds} variant="contained" fullWidth style={{ width: "100%" }}>
                Release funds
              </PopupActionButton>
            )}
            <PopupGhostButton onClick={() => setReleaseTarget(null)} disabled={releaseLoading} fullWidth>
              Cancel
            </PopupGhostButton>
          </Box>
          <p style={{ fontSize: "13px", color: "#888", textAlign: "center" }}>
            The release is signed with your wallet and submitted gaslessly — the chosen resolution is executed on-chain.
          </p>
        </Wrapper>
      </DialogInfo>

      {/* Reassign Pop up */}
      <MuiDialog
        open={reassignOpen}
        onClose={handleReassignClose}
        maxWidth={false}
        {...modalTransitionProps}
        PaperProps={{
          sx: {
            width: isSmallScreen ? "90vw" : "318px",
            maxWidth: isSmallScreen ? "318px" : "318px",
            maxHeight: isSmallScreen ? "90vh" : "auto",
            borderRadius: "20px",
            backgroundColor: "white",
            boxShadow: "none",
            overflow: "visible",
            m: isSmallScreen ? 1 : 2,
          },
        }}
        sx={{
          backdropFilter: "blur(8px)",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          "& .MuiDialog-container": {
            alignItems: isSmallScreen ? "center" : "center",
          },
        }}
      >
        <DialogContent
          sx={{
            p: 0,
            backgroundImage: "linear-gradient(to bottom, #ccc 30%, white 30%)",
            overflow: "hidden",
            borderRadius: "20px",
          }}
        >
          {/* Tabs Section - OrgPopUp Style */}
          <HeaderRow>
            <HalfArea side="left" active={reassignTab === "search"}>
              {reassignTab !== "search" ? (
                <PillBox>
                  <TabLabelButton
                    disableFocusRipple
                    disableRipple
                    disableTouchRipple
                    onClick={() => {
                      setReassignTab("search");
                      setSelectedUser(null);
                      setSearchValue("");
                    }}
                    sx={{ width: "auto", height: "auto", minWidth: 0, padding: "0 12px", color: "#000" }}
                  >
                    All Trustees
                  </TabLabelButton>
                </PillBox>
              ) : (
                <TabLabelButton
                  disableFocusRipple
                  disableRipple
                  disableTouchRipple
                  onClick={() => {
                    setReassignTab("search");
                    setSelectedUser(null);
                    setSearchValue("");
                  }}
                >
                  All Trustees
                </TabLabelButton>
              )}
            </HalfArea>
            <HalfArea side="right" active={reassignTab === "all"}>
              {reassignTab !== "all" ? (
                <PillBox>
                  <TabLabelButton
                    disableFocusRipple
                    disableRipple
                    disableTouchRipple
                    onClick={() => {
                      setReassignTab("all");
                      setSelectedUser(null);
                      setSearchValue("");
                    }}
                    sx={{ width: "auto", height: "auto", minWidth: 0, padding: "0 12px", color: "#000" }}
                  >
                    Claimed
                  </TabLabelButton>
                </PillBox>
              ) : (
                <TabLabelButton
                  disableFocusRipple
                  disableRipple
                  disableTouchRipple
                  onClick={() => {
                    setReassignTab("all");
                    setSelectedUser(null);
                    setSearchValue("");
                  }}
                >
                  Claimed
                </TabLabelButton>
              )}
            </HalfArea>
          </HeaderRow>

          {/* Claimed Section */}
          {reassignTab === "all" ? (
            // Main Container - 318px x 497px
            <Box
              sx={{
                width: "100%",
                height: isSmallScreen ? "auto" : "497px",
                maxHeight: isSmallScreen ? "calc(90vh - 100px)" : "497px",
                margin: "0 auto",
                position: "relative",
                borderRadius: reassignTab !== "all" ? "0 20px 20px 20px" : "20px 0 20px 20px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {selectedUser ? (
                // SELECTED STATE - Show purple button, single trustee, and details
                <>
                  {/* Purple Button Section - 90px */}

                  {/* Beige Section - Single Trustee Row */}
                  <Box
                    sx={{
                      flex: "0 0 auto",
                      minHeight: "200px",
                      backgroundColor: "#ede1dc",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "0 0 20px 20px",
                    }}
                  >
                    {/* Table Header */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: "25px",
                        pt: "24px",
                        mx: "24px",
                        pb: "12px",
                        borderBottom: "1px solid black",
                        fontSize: "12px",
                        fontFamily: "IBM Plex Mono, monospace",
                        textTransform: "uppercase",
                        color: "black",
                        fontWeight: 400,
                      }}
                    >
                      <Box sx={{ width: "51px", flexShrink: 0 }}>Trustee</Box>
                      <Box sx={{ width: "44px", flexShrink: 0 }}>Region</Box>
                      <Box sx={{ width: "36px", flexShrink: 0 }}>Lands</Box>
                      <Box sx={{ width: "65px", flexShrink: 0 }}>Portfolio</Box>
                    </Box>

                    {/* Single Selected Trustee */}
                    <Box
                      sx={{
                        px: "24px",
                        pt: "12px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: "25px",
                          alignItems: "center",
                          py: "8px",
                        }}
                      >
                        <Box
                          component="img"
                          src={selectedUser.profilePicture || "https://via.placeholder.com/47"}
                          sx={{
                            width: "47px",
                            height: "47px",
                            borderRadius: "18px",
                            objectFit: "cover",
                            flexShrink: 0,
                          }}
                        />

                        <Box
                          sx={{
                            width: "44px",
                            flexShrink: 0,
                            fontSize: "12px",
                            fontFamily: "IBM Plex Mono, monospace",
                            textTransform: "uppercase",
                            lineHeight: "17.67px",
                          }}
                        >
                          <Box component="span" sx={{ display: "block", color: "black" }}>
                            {selectedUser.patronymic?.split(",")[0]?.trim()?.substring(0, 2).toUpperCase() || "WP"}
                          </Box>
                          <Box component="span" sx={{ display: "block", color: "#666666" }}>
                            {selectedUser.country?.split(",")[1]?.trim()?.substring(0, 2).toUpperCase() || "LK"}
                          </Box>
                        </Box>

                        <Box
                          sx={{
                            width: "36px",
                            flexShrink: 0,
                            fontSize: "12px",
                            fontFamily: "IBM Plex Mono, monospace",
                            textTransform: "uppercase",
                            color: "black",
                          }}
                        >
                          {selectedUser.portfolio?.claimedLandsCount || "0"}
                        </Box>

                        <Box
                          sx={{
                            width: "65px",
                            flexShrink: 0,
                            fontSize: "12px",
                            fontFamily: "IBM Plex Mono, monospace",
                            lineHeight: "17.67px",
                          }}
                        >
                          <Box component="span" sx={{ display: "block", color: "black" }}>
                            {selectedUser.portfolio?.portfolioSum
                              ? toReadable(selectedUser.portfolio.portfolioSum)
                              : "0"}
                          </Box>
                          <Box component="span" sx={{ display: "block", color: "#666666" }}>
                            USD
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        flex: "0px",
                        backgroundColor: "transparent",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        px: "24px",
                      }}
                    >
                      <ActionBtn
                        onClick={() => handleReassignToTrustee(selectedUser.address, ecoFuturesData.id)}
                        disabled={isLoading}
                        sx={{
                          width: isSmallScreen ? "calc(100% - 48px)" : "270px",
                          maxWidth: "270px",
                          height: "40px",
                          backgroundColor: "#bc92f8",
                          borderRadius: "20px",
                          fontSize: "14px",
                          fontFamily: "Inter, sans-serif",
                          fontWeight: 500,
                          color: "white",
                          border: "none",
                          textTransform: "none",
                          "&:hover": {
                            backgroundColor: "#a67ae8",
                          },
                          "&:disabled": {
                            backgroundColor: "#ddd",
                            color: "#999",
                          },
                        }}
                      >
                        {isLoading ? "Assigning..." : "Assign to this Trustee"}
                      </ActionBtn>
                    </Box>
                  </Box>

                  {/* White Bottom Section - Wallet and Details */}
                  <Box
                    sx={{
                      flex: 1,
                      backgroundColor: "white",
                      px: "24px",
                      pt: "16px",
                      pb: "24px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                      overflowY: "auto",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* Detailed Trustee Information */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      {/* Name */}
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          fontSize: "14px",
                          fontFamily: "Inter, sans-serif",
                          alignItems: "flex-start",
                        }}
                      >
                        {/* <Box sx={{ color: '#999999', minWidth: '70px', flexShrink: 0 }}>Name:</Box> */}
                        <Box sx={{ color: "black", fontWeight: 700, flex: 1, wordBreak: "break-word" }}>
                          {selectedUser.name || "Unnamed Trustee"}
                        </Box>
                      </Box>

                      {/* Role */}
                      {/* <Box sx={{
                                            display: 'flex',
                                            gap: '10px',
                                            fontSize: '14px',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            <Box sx={{ color: '#999999', minWidth: '70px', flexShrink: 0 }}>Role:</Box>
                                            <Box sx={{ color: 'black', flex: 1 }}>Trustee</Box>
                                        </Box> */}

                      {/* Email */}
                      {selectedUser.email && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          <Box sx={{ color: "#666", minWidth: "70px", flexShrink: 0 }}>Email:</Box>
                          <Box sx={{ color: "black", flex: 1, wordBreak: "break-word" }}>{selectedUser.email}</Box>
                        </Box>
                      )}

                      {/* Phone */}
                      {selectedUser.phone && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          <Box sx={{ color: "#666", minWidth: "70px", flexShrink: 0 }}>Phone:</Box>
                          <Box sx={{ color: "black", flex: 1 }}>{selectedUser.phone}</Box>
                        </Box>
                      )}

                      {/* Region */}
                      {selectedUser.country && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          <Box sx={{ color: "#666", minWidth: "70px", flexShrink: 0 }}>Region:</Box>
                          <Box sx={{ color: "black", flex: 1 }}>{selectedUser.patronymic}</Box>
                        </Box>
                      )}

                      {/* Region */}
                      {/* {selectedUser.country && (
                                                <Box sx={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                    fontSize: '14px',
                                                    fontFamily: 'Inter, sans-serif'
                                                }}>
                                                    <Box sx={{ color: '#666', minWidth: '70px', flexShrink: 0 }}>Flags:</Box>
                                                    <Box sx={{ color: 'black', flex: 1 }}>{selectedUser.flags.length}</Box>
                                                </Box>
                                            )} */}

                      {/* Wallet */}
                      {selectedUser.address && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          <Box sx={{ color: "#666", minWidth: "70px", flexShrink: 0 }}>Wallet:</Box>
                          <Box sx={{ flex: 1 }}>
                            <AddressLink
                              sx={{
                                fontSize: "14px",
                                textDecoration: "underline",
                                color: "black",
                              }}
                              type="user"
                              address={selectedUser.address}
                              links={false}
                            />
                          </Box>
                        </Box>
                      )}

                      {/* Proof of ID */}
                      {selectedUser.proofOfId && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          <Box sx={{ color: "#666", minWidth: "70px", flexShrink: 0 }}>Proof of ID:</Box>
                          <Box sx={{ color: "black", flex: 1, wordBreak: "break-word" }}>
                            {selectedUser?.proofOfId ? (
                              <a
                                href={selectedUser.proofOfId}
                                style={{ all: "unset", cursor: "pointer", textDecoration: "underline" }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </Box>
                        </Box>
                      )}
                    </Box>

                    {/* Wallet Address with Close Icon */}
                    <Box sx={{ position: "relative" }}>
                      <TextField
                        value={searchValue}
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <Box
                              onClick={() => {
                                setSearchValue("");
                                setSelectedUser(null);
                              }}
                              sx={{
                                width: "27px",
                                height: "27px",
                                borderRadius: "50%",
                                backgroundColor: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                "&:hover": {
                                  backgroundColor: "#f5f5f5",
                                },
                              }}
                            >
                              <CloseIcon sx={{ fontSize: "16px", color: "#666" }} />
                            </Box>
                          ),
                          sx: {
                            height: "40px",
                            backgroundColor: "#f2f2f2",
                            borderRadius: "20px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                            "& fieldset": {
                              border: "none",
                            },
                            "& input": {
                              padding: "10px 14px",
                              height: "40px",
                              boxSizing: "border-box",
                              textAlign: "center",
                            },
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </>
              ) : (
                // NORMAL STATE - Show scrollable trustee list and search
                <>
                  {/* Beige Background Area - Top section with rounded bottom */}
                  <Box
                    sx={{
                      flex: isSmallScreen ? "1" : "0 0 373px",
                      minHeight: isSmallScreen ? "200px" : "370px",
                      maxHeight: isSmallScreen ? "calc(90vh - 200px)" : "373px",
                      backgroundColor: "#ede1dc",
                      borderRadius: "0 0 20px 20px",
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                    }}
                  >
                    {/* Table Header - pt: 24px, px: 24px, pb: 12px */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: "25px",
                        pt: "24px",
                        mx: "24px",
                        pb: "12px",
                        borderBottom: "1px solid black",
                        fontSize: "12px",
                        fontFamily: "IBM Plex Mono, monospace",
                        textTransform: "uppercase",
                        color: "black",
                        fontWeight: 400,
                      }}
                    >
                      <Box sx={{ width: "51px", flexShrink: 0 }}>Trustee</Box>
                      <Box sx={{ width: "44px", flexShrink: 0 }}>Region</Box>
                      <Box sx={{ width: "36px", flexShrink: 0 }}>Lands</Box>
                      <Box sx={{ width: "65px", flexShrink: 0 }}>Portfolio</Box>
                    </Box>

                    {/* Scrollable Trustee List */}
                    <Box
                      sx={{
                        flex: 1,
                        overflowY: "auto",
                        pt: "12px",
                        px: "24px",
                        "&::-webkit-scrollbar": {
                          width: "4px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "rgba(0,0,0,.2)",
                          borderRadius: "4px",
                        },
                      }}
                    >
                      {/* Loading message */}
                      {loadingPendingReassignees ? (
                        <Box
                          sx={{
                            py: "24px",
                            textAlign: "center",
                            color: "#666",
                            fontSize: "14px",
                          }}
                        >
                          Loading trustees...
                        </Box>
                      ) : (
                        <>
                          {(() => {
                            // Convert pendingReassignees object to array and extract users
                            const allPendingUsers = Object.values(pendingReassignees || {})
                              .map((item: any) => item?.user)
                              .filter(Boolean);

                            const filteredTrustees = allPendingUsers.filter((trustee: any) => {
                              if (trustee?.role !== "trust") return false;
                              if (trustee?.status !== "active") return false;
                              if (ecoFuturesData?.trustId && trustee?.id === ecoFuturesData?.trustId) return false;

                              if (ecoFuturesData?.meta?.location) {
                                try {
                                  const landLocation =
                                    typeof ecoFuturesData.meta.location === "string"
                                      ? JSON.parse(ecoFuturesData.meta.location)
                                      : ecoFuturesData.meta.location;
                                  const landCountry = landLocation?.country;

                                  if (landCountry && trustee?.country) {
                                    return (
                                      trustee.country.includes(landCountry) || landCountry.includes(trustee.country)
                                    );
                                  }
                                } catch (e) {
                                  console.log("Error parsing location:", e);
                                }
                              }

                              return true;
                            });

                            // Apply search filter if searchValue exists
                            const searchFilteredTrustees = searchValue
                              ? filteredTrustees.filter((trustee: any) =>
                                  trustee.address?.toLowerCase().includes(searchValue.toLowerCase())
                                )
                              : filteredTrustees;

                            return searchFilteredTrustees.map((trustee: any) => (
                              <Box
                                key={trustee.id}
                                onClick={() => {
                                  setSelectedUser(trustee);
                                  setSearchValue(trustee.address || "");
                                }}
                                sx={{
                                  display: "flex",
                                  gap: "25px",
                                  alignItems: "center",
                                  py: "8px",
                                  cursor: "pointer",
                                  transition: "opacity 0.2s",
                                  "&:hover": {
                                    opacity: 0.8,
                                  },
                                }}
                              >
                                {/* Profile Image - 47px */}
                                <Box
                                  component="img"
                                  src={trustee.profilePicture || "https://via.placeholder.com/47"}
                                  sx={{
                                    width: "47px",
                                    height: "47px",
                                    borderRadius: 50,
                                    objectFit: "cover",
                                    flexShrink: 0,
                                  }}
                                />

                                {/* Region - 44px width */}
                                <Box
                                  sx={{
                                    width: "44px",
                                    flexShrink: 0,
                                    fontSize: "12px",
                                    fontFamily: "IBM Plex Mono, monospace",
                                    textTransform: "uppercase",
                                    lineHeight: "17.67px",
                                  }}
                                >
                                  <Box component="span" sx={{ display: "block", color: "black" }}>
                                    {trustee.patronymic?.split(",")[0]?.trim()?.substring(0, 2).toUpperCase() || "WP"}
                                  </Box>
                                  <Box component="span" sx={{ display: "block", color: "#666666" }}>
                                    {trustee.country?.split(",")[1]?.trim()?.substring(0, 2).toUpperCase() || "LK"}
                                  </Box>
                                </Box>

                                {/* Lands - 36px width */}
                                <Box
                                  sx={{
                                    width: "36px",
                                    flexShrink: 0,
                                    fontSize: "12px",
                                    fontFamily: "IBM Plex Mono, monospace",
                                    textTransform: "uppercase",
                                    color: "black",
                                  }}
                                >
                                  {trustee.portfolio?.claimedLandsCount || "0"}
                                </Box>

                                {/* Portfolio - 65px width */}
                                <Box
                                  sx={{
                                    width: "65px",
                                    flexShrink: 0,
                                    fontSize: "12px",
                                    fontFamily: "IBM Plex Mono, monospace",
                                    lineHeight: "17.67px",
                                  }}
                                >
                                  <Box component="span" sx={{ display: "block", color: "black" }}>
                                    {trustee.portfolio?.portfolioSum ? toReadable(trustee.portfolio.portfolioSum) : "0"}
                                  </Box>
                                  <Box component="span" sx={{ display: "block", color: "#666666" }}>
                                    USD
                                  </Box>
                                </Box>
                              </Box>
                            ));
                          })()}

                          {/* No trustees message */}
                          {(() => {
                            // Convert pendingReassignees object to array and extract users
                            const allPendingUsers = Object.values(pendingReassignees || {})
                              .map((item: any) => item?.user)
                              .filter(Boolean);

                            const filteredTrustees = allPendingUsers.filter((trustee: any) => {
                              if (trustee?.role !== "trust") return false;
                              if (trustee?.status !== "active") return false;
                              if (ecoFuturesData?.trustId && trustee?.id === ecoFuturesData?.trustId) return false;
                              if (ecoFuturesData?.meta?.location) {
                                try {
                                  const landLocation =
                                    typeof ecoFuturesData.meta.location === "string"
                                      ? JSON.parse(ecoFuturesData.meta.location)
                                      : ecoFuturesData.meta.location;
                                  const landCountry = landLocation?.country;
                                  if (landCountry && trustee?.country) {
                                    return (
                                      trustee.country.includes(landCountry) || landCountry.includes(trustee.country)
                                    );
                                  }
                                } catch (e) {
                                  console.log("Error parsing location:", e);
                                }
                              }
                              return true;
                            });

                            // Apply search filter
                            const searchFilteredTrustees = searchValue
                              ? filteredTrustees.filter((trustee: any) =>
                                  trustee.address?.toLowerCase().includes(searchValue.toLowerCase())
                                )
                              : filteredTrustees;

                            if (searchFilteredTrustees.length === 0) {
                              return (
                                <Box
                                  sx={{
                                    py: "24px",
                                    textAlign: "center",
                                    color: "#666",
                                    fontSize: "14px",
                                  }}
                                >
                                  {searchValue
                                    ? `No trustees found matching "${searchValue.substring(0, 10)}..."`
                                    : "No trustees available"}
                                </Box>
                              );
                            }
                            return null;
                          })()}
                        </>
                      )}
                    </Box>
                  </Box>

                  {/* White Bottom Section - Search Area ~124px */}
                  <Box
                    sx={{
                      flex: "0 0 auto",
                      minHeight: "124px",
                      backgroundColor: "white",
                      borderRadius: "20px 20px 0 0",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      px: isSmallScreen ? "16px" : "24px",
                      pb: isSmallScreen ? "16px" : "24px",
                      pt: "12px",
                    }}
                  >
                    {/* Search Label */}
                    <Box
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Inter, sans-serif",
                        color: "black",
                        mb: "12px",
                        fontWeight: 400,
                      }}
                    >
                      Search for a Trustee
                    </Box>

                    {/* Search Input - 270px width, 39.76px height */}
                    <Box
                      sx={{
                        width: isSmallScreen ? "100%" : "270px",
                        maxWidth: "270px",
                        height: "39.76px",
                        position: "relative",
                      }}
                    >
                      <TextField
                        placeholder="Wallet address"
                        fullWidth
                        variant="outlined"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        InputProps={{
                          endAdornment: searchValue ? (
                            <CloseIcon
                              onClick={() => {
                                setSearchValue("");
                                setSelectedUser(null);
                              }}
                              sx={{
                                color: "#999",
                                fontSize: "16px",
                                cursor: "pointer",
                                "&:hover": {
                                  color: "#666",
                                },
                              }}
                            />
                          ) : (
                            <SearchIcon sx={{ color: "#999", fontSize: "16px" }} />
                          ),
                          sx: {
                            height: "39.76px",
                            backgroundColor: "#f2f2f2",
                            borderRadius: "20px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                            "& fieldset": {
                              border: "none",
                            },
                            "& input": {
                              padding: "10px 14px",
                              height: "39.76px",
                              boxSizing: "border-box",
                            },
                            "& input::placeholder": {
                              color: "black",
                              opacity: 1,
                            },
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          ) : (
            //  All Trustees Section
            <Box
              sx={{
                width: "100%",
                height: isSmallScreen ? "auto" : "497px",
                maxHeight: isSmallScreen ? "calc(90vh - 100px)" : "497px",
                margin: "0 auto",
                position: "relative",
                borderRadius: "0 20px 20px 20px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {selectedUser ? (
                // SELECTED STATE - Show purple button, single trustee, and details
                <>
                  {/* Purple Button Section - 90px */}

                  {/* Beige Section - Single Trustee Row */}
                  <Box
                    sx={{
                      flex: "0 0 auto",
                      minHeight: "200px",
                      backgroundColor: "#ede1dc",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "0 0 20px 20px",
                    }}
                  >
                    {/* Table Header */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: "25px",
                        pt: "24px",
                        mx: "24px",
                        pb: "12px",
                        borderBottom: "1px solid black",
                        fontSize: "12px",
                        fontFamily: "IBM Plex Mono, monospace",
                        textTransform: "uppercase",
                        color: "black",
                        fontWeight: 400,
                      }}
                    >
                      <Box sx={{ width: "51px", flexShrink: 0 }}>Trustee</Box>
                      <Box sx={{ width: "44px", flexShrink: 0 }}>Region</Box>
                      <Box sx={{ width: "36px", flexShrink: 0 }}>Lands</Box>
                      <Box sx={{ width: "65px", flexShrink: 0 }}>Portfolio</Box>
                    </Box>

                    {/* Single Selected Trustee */}
                    <Box
                      sx={{
                        px: "24px",
                        pt: "12px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: "25px",
                          alignItems: "center",
                          py: "8px",
                        }}
                      >
                        <Box
                          component="img"
                          src={selectedUser.profilePicture || "https://via.placeholder.com/47"}
                          sx={{
                            width: "47px",
                            height: "47px",
                            borderRadius: "18px",
                            objectFit: "cover",
                            flexShrink: 0,
                          }}
                        />

                        <Box
                          sx={{
                            width: "44px",
                            flexShrink: 0,
                            fontSize: "12px",
                            fontFamily: "IBM Plex Mono, monospace",
                            textTransform: "uppercase",
                            lineHeight: "17.67px",
                          }}
                        >
                          <Box component="span" sx={{ display: "block", color: "black" }}>
                            {selectedUser.patronymic?.split(",")[0]?.trim()?.substring(0, 2).toUpperCase() || "WP"}
                          </Box>
                          <Box component="span" sx={{ display: "block", color: "#666666" }}>
                            {selectedUser.country?.split(",")[1]?.trim()?.substring(0, 2).toUpperCase() || "LK"}
                          </Box>
                        </Box>

                        <Box
                          sx={{
                            width: "36px",
                            flexShrink: 0,
                            fontSize: "12px",
                            fontFamily: "IBM Plex Mono, monospace",
                            textTransform: "uppercase",
                            color: "black",
                          }}
                        >
                          {selectedUser.portfolio?.claimedLandsCount || "0"}
                        </Box>

                        <Box
                          sx={{
                            width: "65px",
                            flexShrink: 0,
                            fontSize: "12px",
                            fontFamily: "IBM Plex Mono, monospace",
                            lineHeight: "17.67px",
                          }}
                        >
                          <Box component="span" sx={{ display: "block", color: "black" }}>
                            {selectedUser.portfolio?.portfolioSum
                              ? toReadable(selectedUser.portfolio.portfolioSum)
                              : "0"}
                          </Box>
                          <Box component="span" sx={{ display: "block", color: "#666666" }}>
                            USD
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        flex: "0px",
                        backgroundColor: "transparent",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        px: "24px",
                      }}
                    >
                      <ActionBtn
                        onClick={() => handleReassignToken(selectedUser.address, ecoFuturesData.id)}
                        disabled={isLoading}
                        sx={{
                          width: isSmallScreen ? "calc(100% - 48px)" : "270px",
                          maxWidth: "270px",
                          height: "40px",
                          backgroundColor: "#000",
                          borderRadius: "20px",
                          fontSize: "14px",
                          fontFamily: "Inter, sans-serif",
                          fontWeight: 500,
                          color: "white",
                          border: "none",
                          textTransform: "none",
                          "&:hover": {
                            backgroundColor: "#000",
                            color: "#fff",
                          },
                          "&:disabled": {
                            backgroundColor: "#000",
                            color: "#999",
                          },
                        }}
                      >
                        {isLoading ? "Assigning..." : "Assign to this Trustee"}
                      </ActionBtn>
                    </Box>
                  </Box>

                  {/* White Bottom Section - Wallet and Details */}
                  <Box
                    sx={{
                      flex: 1,
                      backgroundColor: "white",
                      px: "24px",
                      pt: "16px",
                      pb: "24px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                      overflowY: "auto",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* Detailed Trustee Information */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      {/* Name */}
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          fontSize: "14px",
                          fontFamily: "Inter, sans-serif",
                          alignItems: "flex-start",
                        }}
                      >
                        {/* <Box sx={{ color: '#999999', minWidth: '70px', flexShrink: 0 }}>Name:</Box> */}
                        <Box sx={{ color: "black", fontWeight: 700, flex: 1, wordBreak: "break-word" }}>
                          {selectedUser.name || "Unnamed Trustee"}
                        </Box>
                      </Box>

                      {/* Role */}
                      {/* <Box sx={{
                                            display: 'flex',
                                            gap: '10px',
                                            fontSize: '14px',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            <Box sx={{ color: '#999999', minWidth: '70px', flexShrink: 0 }}>Role:</Box>
                                            <Box sx={{ color: 'black', flex: 1 }}>Trustee</Box>
                                        </Box> */}

                      {/* Email */}
                      {selectedUser.email && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          <Box sx={{ color: "#666", minWidth: "70px", flexShrink: 0 }}>Email:</Box>
                          <Box sx={{ color: "black", flex: 1, wordBreak: "break-word" }}>{selectedUser.email}</Box>
                        </Box>
                      )}

                      {/* Phone */}
                      {selectedUser.phone && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          <Box sx={{ color: "#666", minWidth: "70px", flexShrink: 0 }}>Phone:</Box>
                          <Box sx={{ color: "black", flex: 1 }}>{selectedUser.phone}</Box>
                        </Box>
                      )}

                      {/* Region */}
                      {selectedUser.country && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          <Box sx={{ color: "#666", minWidth: "70px", flexShrink: 0 }}>Region:</Box>
                          <Box sx={{ color: "black", flex: 1 }}>{selectedUser.patronymic}</Box>
                        </Box>
                      )}

                      {/* Region */}
                      {/* {selectedUser.country && (
                                                <Box sx={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                    fontSize: '14px',
                                                    fontFamily: 'Inter, sans-serif'
                                                }}>
                                                    <Box sx={{ color: '#666', minWidth: '70px', flexShrink: 0 }}>Flags:</Box>
                                                    <Box sx={{ color: 'black', flex: 1 }}>{selectedUser.flags.length}</Box>
                                                </Box>
                                            )} */}

                      {/* Wallet */}
                      {selectedUser.address && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          <Box sx={{ color: "#666", minWidth: "70px", flexShrink: 0 }}>Wallet:</Box>
                          <Box sx={{ flex: 1 }}>
                            <AddressLink
                              sx={{
                                fontSize: "14px",
                                textDecoration: "underline",
                                color: "black",
                              }}
                              type="user"
                              address={selectedUser.address}
                              links={false}
                            />
                          </Box>
                        </Box>
                      )}

                      {/* Proof of ID */}
                      {selectedUser.proofOfId && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          <Box sx={{ color: "#666", minWidth: "70px", flexShrink: 0 }}>Proof of ID:</Box>
                          <Box sx={{ color: "black", flex: 1, wordBreak: "break-word" }}>
                            {selectedUser?.proofOfId ? (
                              <a
                                href={selectedUser.proofOfId}
                                style={{ all: "unset", cursor: "pointer", textDecoration: "underline" }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </Box>
                        </Box>
                      )}
                    </Box>

                    {/* Wallet Address with Close Icon */}
                    <Box sx={{ position: "relative" }}>
                      <TextField
                        value={searchValue}
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <Box
                              onClick={() => {
                                setSearchValue("");
                                setSelectedUser(null);
                              }}
                              sx={{
                                width: "27px",
                                height: "27px",
                                borderRadius: "50%",
                                backgroundColor: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                "&:hover": {
                                  backgroundColor: "#f5f5f5",
                                },
                              }}
                            >
                              <CloseIcon sx={{ fontSize: "16px", color: "#666" }} />
                            </Box>
                          ),
                          sx: {
                            height: "40px",
                            backgroundColor: "#f2f2f2",
                            borderRadius: "20px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                            "& fieldset": {
                              border: "none",
                            },
                            "& input": {
                              padding: "10px 14px",
                              height: "40px",
                              boxSizing: "border-box",
                              textAlign: "center",
                            },
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </>
              ) : (
                // NORMAL STATE - Show scrollable trustee list and search
                <>
                  {/* Beige Background Area - Top section with rounded bottom */}
                  <Box
                    sx={{
                      flex: isSmallScreen ? "1" : "0 0 373px",
                      minHeight: isSmallScreen ? "200px" : "370px",
                      maxHeight: isSmallScreen ? "calc(90vh - 200px)" : "373px",
                      backgroundColor: "#ede1dc",
                      borderRadius: "0 0 20px 20px",
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                    }}
                  >
                    {/* Table Header - pt: 24px, px: 24px, pb: 12px */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: "25px",
                        pt: "24px",
                        mx: "24px",
                        pb: "12px",
                        borderBottom: "1px solid black",
                        fontSize: "12px",
                        fontFamily: "IBM Plex Mono, monospace",
                        textTransform: "uppercase",
                        color: "black",
                        fontWeight: 400,
                      }}
                    >
                      <Box sx={{ width: "51px", flexShrink: 0 }}>Trustee</Box>
                      <Box sx={{ width: "44px", flexShrink: 0 }}>Region</Box>
                      <Box sx={{ width: "36px", flexShrink: 0 }}>Lands</Box>
                      <Box sx={{ width: "65px", flexShrink: 0 }}>Portfolio</Box>
                    </Box>

                    {/* Scrollable Trustee List */}
                    <Box
                      sx={{
                        flex: 1,
                        overflowY: "auto",
                        pt: "12px",
                        px: "24px",
                        "&::-webkit-scrollbar": {
                          width: "4px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "rgba(0,0,0,.2)",
                          borderRadius: "4px",
                        },
                      }}
                    >
                      {/* Loading message */}
                      {loadingPendingReassignees ? (
                        <Box
                          sx={{
                            py: "24px",
                            textAlign: "center",
                            color: "#666",
                            fontSize: "14px",
                          }}
                        >
                          Loading trustees...
                        </Box>
                      ) : (
                        <>
                          {(() => {
                            // Get list of pending trustee IDs to exclude them
                            const pendingTrusteeIds = Object.values(pendingReassignees || {})
                              .map((item: any) => item?.user?.id)
                              .filter(Boolean);

                            const filteredTrustees =
                              trusteeData?.filter((trustee: any) => {
                                if (trustee?.role !== "trust") return false;
                                if (trustee?.status !== "active") return false;
                                if (ecoFuturesData?.trustId && trustee?.id === ecoFuturesData?.trustId) return false;

                                // Exclude trustees that are already in pendingReassignees
                                if (pendingTrusteeIds.includes(trustee?.id)) return false;

                                if (ecoFuturesData?.meta?.location) {
                                  try {
                                    const landLocation =
                                      typeof ecoFuturesData.meta.location === "string"
                                        ? JSON.parse(ecoFuturesData.meta.location)
                                        : ecoFuturesData.meta.location;
                                    const landCountry = landLocation?.country;

                                    if (landCountry && trustee?.country) {
                                      return (
                                        trustee.country.includes(landCountry) || landCountry.includes(trustee.country)
                                      );
                                    }
                                  } catch (e) {
                                    console.log("Error parsing location:", e);
                                  }
                                }

                                return true;
                              }) || [];

                            // Apply search filter if searchValue exists
                            const searchFilteredTrustees = searchValue
                              ? filteredTrustees.filter((trustee: any) =>
                                  trustee.address?.toLowerCase().includes(searchValue.toLowerCase())
                                )
                              : filteredTrustees;

                            return searchFilteredTrustees.map((trustee: any) => (
                              <Box
                                key={trustee.id}
                                onClick={() => {
                                  setSelectedUser(trustee);
                                  setSearchValue(trustee.address || "");
                                }}
                                sx={{
                                  display: "flex",
                                  gap: "25px",
                                  alignItems: "center",
                                  py: "8px",
                                  cursor: "pointer",
                                  transition: "opacity 0.2s",
                                  "&:hover": {
                                    opacity: 0.8,
                                  },
                                }}
                              >
                                {/* Profile Image - 47px */}
                                <Box
                                  component="img"
                                  src={trustee.profilePicture || "https://via.placeholder.com/47"}
                                  sx={{
                                    width: "47px",
                                    height: "47px",
                                    borderRadius: 50,
                                    objectFit: "cover",
                                    flexShrink: 0,
                                  }}
                                />

                                {/* Region - 44px width */}
                                <Box
                                  sx={{
                                    width: "44px",
                                    flexShrink: 0,
                                    fontSize: "12px",
                                    fontFamily: "IBM Plex Mono, monospace",
                                    textTransform: "uppercase",
                                    lineHeight: "17.67px",
                                  }}
                                >
                                  <Box component="span" sx={{ display: "block", color: "black" }}>
                                    {trustee.patronymic?.split(",")[0]?.trim()?.substring(0, 2).toUpperCase() || "WP"}
                                  </Box>
                                  <Box component="span" sx={{ display: "block", color: "#666666" }}>
                                    {trustee.country?.split(",")[1]?.trim()?.substring(0, 2).toUpperCase() || "LK"}
                                  </Box>
                                </Box>

                                {/* Lands - 36px width */}
                                <Box
                                  sx={{
                                    width: "36px",
                                    flexShrink: 0,
                                    fontSize: "12px",
                                    fontFamily: "IBM Plex Mono, monospace",
                                    textTransform: "uppercase",
                                    color: "black",
                                  }}
                                >
                                  {trustee.portfolio?.claimedLandsCount || "0"}
                                </Box>

                                {/* Portfolio - 65px width */}
                                <Box
                                  sx={{
                                    width: "65px",
                                    flexShrink: 0,
                                    fontSize: "12px",
                                    fontFamily: "IBM Plex Mono, monospace",
                                    lineHeight: "17.67px",
                                  }}
                                >
                                  <Box component="span" sx={{ display: "block", color: "black" }}>
                                    {trustee.portfolio?.portfolioSum ? toReadable(trustee.portfolio.portfolioSum) : "0"}
                                  </Box>
                                  <Box component="span" sx={{ display: "block", color: "#666666" }}>
                                    USD
                                  </Box>
                                </Box>
                              </Box>
                            ));
                          })()}

                          {/* No trustees message */}
                          {(() => {
                            // Get list of pending trustee IDs to exclude them
                            const pendingTrusteeIds = Object.values(pendingReassignees || {})
                              .map((item: any) => item?.user?.id)
                              .filter(Boolean);

                            const filteredTrustees =
                              trusteeData?.filter((trustee: any) => {
                                if (trustee?.role !== "trust") return false;
                                if (trustee?.status !== "active") return false;
                                if (ecoFuturesData?.trustId && trustee?.id === ecoFuturesData?.trustId) return false;

                                // Exclude trustees that are already in pendingReassignees
                                if (pendingTrusteeIds.includes(trustee?.id)) return false;

                                if (ecoFuturesData?.meta?.location) {
                                  try {
                                    const landLocation =
                                      typeof ecoFuturesData.meta.location === "string"
                                        ? JSON.parse(ecoFuturesData.meta.location)
                                        : ecoFuturesData.meta.location;
                                    const landCountry = landLocation?.country;
                                    if (landCountry && trustee?.country) {
                                      return (
                                        trustee.country.includes(landCountry) || landCountry.includes(trustee.country)
                                      );
                                    }
                                  } catch (e) {
                                    console.log("Error parsing location:", e);
                                  }
                                }
                                return true;
                              }) || [];

                            // Apply search filter
                            const searchFilteredTrustees = searchValue
                              ? filteredTrustees.filter((trustee: any) =>
                                  trustee.address?.toLowerCase().includes(searchValue.toLowerCase())
                                )
                              : filteredTrustees;

                            if (searchFilteredTrustees.length === 0) {
                              return (
                                <Box
                                  sx={{
                                    py: "24px",
                                    textAlign: "center",
                                    color: "#666",
                                    fontSize: "14px",
                                  }}
                                >
                                  {searchValue
                                    ? `No trustees found matching "${searchValue.substring(0, 10)}..."`
                                    : "No trustees available"}
                                </Box>
                              );
                            }
                            return null;
                          })()}
                        </>
                      )}
                    </Box>
                  </Box>

                  {/* White Bottom Section - Search Area ~124px */}
                  <Box
                    sx={{
                      flex: "0 0 auto",
                      minHeight: "124px",
                      backgroundColor: "white",
                      borderRadius: "20px 20px 0 0",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      px: isSmallScreen ? "16px" : "24px",
                      pb: isSmallScreen ? "16px" : "24px",
                      pt: "12px",
                    }}
                  >
                    {/* Search Label */}
                    <Box
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Inter, sans-serif",
                        color: "black",
                        mb: "12px",
                        fontWeight: 400,
                      }}
                    >
                      Search for a Trustee
                    </Box>

                    {/* Search Input - 270px width, 39.76px height */}
                    <Box
                      sx={{
                        width: isSmallScreen ? "100%" : "270px",
                        maxWidth: "270px",
                        height: "39.76px",
                        position: "relative",
                      }}
                    >
                      <TextField
                        placeholder="Wallet address"
                        fullWidth
                        variant="outlined"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        InputProps={{
                          endAdornment: searchValue ? (
                            <CloseIcon
                              onClick={() => {
                                setSearchValue("");
                                setSelectedUser(null);
                              }}
                              sx={{
                                color: "#999",
                                fontSize: "16px",
                                cursor: "pointer",
                                "&:hover": {
                                  color: "#666",
                                },
                              }}
                            />
                          ) : (
                            <SearchIcon sx={{ color: "#999", fontSize: "16px" }} />
                          ),
                          sx: {
                            height: "39.76px",
                            backgroundColor: "#f2f2f2",
                            borderRadius: "20px",
                            fontSize: "14px",
                            fontFamily: "Inter, sans-serif",
                            "& fieldset": {
                              border: "none",
                            },
                            "& input": {
                              padding: "10px 14px",
                              height: "39.76px",
                              boxSizing: "border-box",
                            },
                            "& input::placeholder": {
                              color: "black",
                              opacity: 1,
                            },
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          )}
        </DialogContent>
      </MuiDialog>

      {/* Flag Message Dialog */}
      {false && selectedUser && (
        <Box
          sx={{
            padding: "0 24px",
            marginBottom: "16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "12px",
            }}
          >
            <Box
              component="img"
              src={
                selectedUser.profilePicture ||
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7tjAdpSNvf-WrHejyhwa-Wr7iwpONn7x2BNNimgVb0bxMUUf4dkfBcoWRdM7_O_z_ue8"
              }
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <Box>
              <Text sx={{ fontWeight: "bold", fontSize: "14px", display: "block", marginBottom: "2px" }}>
                {selectedUser.name || "Unnamed Trustee"}
              </Text>
              <Text sx={{ fontSize: "14px", color: "#666" }}>Trustee</Text>
            </Box>
          </Box>

          {/* Trustee Info */}
          <Box sx={{ fontSize: "14px", lineHeight: "20px" }}>
            {selectedUser.email && (
              <Text sx={{ display: "block", marginBottom: "4px" }}>
                <span style={{ color: "#999" }}>Email: </span>
                {selectedUser.email}
              </Text>
            )}
            {selectedUser.phone && (
              <Text sx={{ display: "block", marginBottom: "4px" }}>
                <span style={{ color: "#999" }}>Phone: </span>
                {selectedUser.phone}
              </Text>
            )}
            {selectedUser.country && (
              <Text sx={{ display: "block", marginBottom: "4px" }}>
                <span style={{ color: "#999" }}>Region: </span>
                {selectedUser.country}
              </Text>
            )}
            {selectedUser.address && (
              <Text sx={{ display: "block", marginBottom: "4px" }}>
                <span style={{ color: "#999" }}>Wallet: </span>
                <AddressLink
                  sx={{ fontSize: "14px", textDecoration: "underline" }}
                  type="user"
                  address={selectedUser.address}
                  links={false}
                />
              </Text>
            )}
            {selectedUser.proofOfId && (
              <Text sx={{ display: "block", marginBottom: "4px" }}>
                <span style={{ color: "#999" }}>Proof of ID: </span>
                {selectedUser.proofOfId.split("/").pop() || "filename.jpg"}
              </Text>
            )}
          </Box>

          {/* Stats Row */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginTop: "12px",
              padding: "12px",
              backgroundColor: "rgba(255,255,255,0.3)",
              borderRadius: "12px",
            }}
          >
            <Box
              component="img"
              src={
                selectedUser.profilePicture ||
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7tjAdpSNvf-WrHejyhwa-Wr7iwpONn7x2BNNimgVb0bxMUUf4dkfBcoWRdM7_O_z_ue8"
              }
              sx={{
                width: 40,
                height: 40,
                borderRadius: "18px",
                objectFit: "cover",
              }}
            />
            <Box sx={{ flex: 1, fontSize: "12px", fontFamily: "monospace" }}>
              <Text sx={{ display: "block", textTransform: "uppercase" }}>
                {selectedUser.country?.substring(0, 2) || "WP"}
              </Text>
              <Text sx={{ display: "block", color: "#666" }}>
                {selectedUser.country?.split(",")[1]?.trim()?.substring(0, 2) || "LK"}
              </Text>
            </Box>
            <Box sx={{ textAlign: "center", fontSize: "12px", fontFamily: "monospace" }}>
              <Text sx={{ display: "block", textTransform: "uppercase" }}>
                {selectedUser.portfolio?.claimedLandsCount || "2"}
              </Text>
            </Box>
            <Box sx={{ textAlign: "right", fontSize: "12px", fontFamily: "monospace" }}>
              <Text sx={{ display: "block" }}>{formatValue(selectedUser.portfolio?.portfolioSum || 0)}</Text>
              <Text sx={{ display: "block", color: "#666" }}>USD</Text>
            </Box>
          </Box>
        </Box>
      )}

      {/* Flag Message Dialog */}
      {/* <DialogPopUp
                open={flagMessageOpen}
                onClose={() => setFlagMessageOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ borderBottom: '1px solid', borderColor: 'divider', pb: 2 }}>
                    Flag Message
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body1" sx={{ fontSize: '16px', lineHeight: 1.6 }}>
                        {selectedFlagMessage}
                    </Typography>
                </DialogContent>
                <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        onClick={() => setFlagMessageOpen(false)}
                        variant="contained"
                        color="primary"
                    >
                        Close
                    </Button>
                </Box>
            </DialogPopUp> */}
      {/* <Modal
                open={flagMessageOpen}
                onClose={() => setFlagMessageOpen(false)}
                sx={{ width: '100%' }}
            >

                <Wrapper
                    sx={{
                        width: '100%',
                        maxWidth: { xs: '315px', md: '600px' },
                        // maxHeight: { xs: '315px', md: '200px' },
                        minWidth: { xs: '315px', md: '600px' },
                        p: { xs: '20px', md: '45px' },
                        backgroundColor: "white",
                        marginTop: { xs: '50px', md: '0px' },
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        borderRadius: '20px',
                    }}
                >
                    <IconContainer
                        sx={{
                            top: { xs: '-30px', md: '-40px' },
                            left: { xs: '0%', md: '50%' },
                            width: { xs: '64px', md: '84px' },
                            padding: { xs: '12px', md: '16px' },
                            transform: { xs: 'translateX(0%)', md: 'translateX(-50%)' },
                        }}>
                        <CircularIcon sx={{ width: { xs: '40px', md: '52px' }, height: { xs: '40px', md: '52px' } }}>
                            <InfoIconOutlined sx={{ fontSize: { xs: '20px', md: '44px' } }} color="primary" />
                        </CircularIcon>
                    </IconContainer>
                    <InfoBody sx={{
                        width: "100%",
                        marginTop: { xs: '12px', md: '0px' },
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "center",
                        padding: { xs: '20px', md: '0px' },
                        gap: '4px',
                    }}>
                        <p style={{ fontWeight: 700, color: 'black', fontSize: "26px", textAlign: "center", marginBottom: "0px" }}>
                            Flag Reason
                        </p>
                        <p style={{ fontWeight: 400, color: 'black', fontSize: "16px", textAlign: "center" }}>
                            {selectedFlagMessage}
                        </p>


                        <Row sx={{
                            flexDirection: { xs: 'column', md: 'row' },
                            width: '100%',
                            marginBottom: 'auto',
                            alignItems: "center",
                            justifyContent: "center",
                        }}>

                            <ActionBtn
                                onClick={() => setFlagMessageOpen(false)}

                                sx={{
                                    padding: "12px 48px",
                                    width: { xs: '100%', md: '145px' },
                                    height: ButtonHeight,
                                    margin: 0,
                                    alignSelf: 'center',
                                    borderRadius: "20px",
                                    backgroundColor: 'black',
                                    ":disabled": {
                                        backgroundColor: 'black',
                                        cursor: 'not-allowed',
                                        color: 'white',
                                    }
                                }}
                                variant="contained"

                            >
                                Close
                            </ActionBtn>

                        </Row>


                    </InfoBody>
                </Wrapper >
            </Modal> */}

      {/* Complaint Modal */}
      <ComplaintModal
        open={complaintModalOpen}
        onClose={handleComplaintModalClose}
        onConfirm={handleComplaintSubmit}
        loading={complaintModalLoading}
        error={complaintModalError}
        land={
          selectedComplaint
            ? ({
                id: selectedComplaint?.ecoTokenId,
                content: selectedComplaint?.content,
                meta: selectedComplaint?.meta,
                trust: selectedComplaint?.trust,
              } as any)
            : null
        }
        title="View Complaint"
        infoText=" If this complaint is accepted, the current verification will be deleted. A new Trustee may then claim the upload and begin the verification process again."
        confirmLabel="Submit Response"
        showReason={false}
        requireDescription={true}
        complaintDescription={selectedComplaint?.description || ""}
        fileUrls={selectedComplaint?.fileUrls || []}
        fileAliases={selectedComplaint?.fileAliases || []}
        isReadOnly={true}
      />
    </Container>
  );
};

const Container = ({ children }: any) => <Profile surface="beige">{children}</Profile>;

// const Col = (props: GridProps) => <Grid {...props} container alignItems="center" direction="column" />;

// Every button in an Actions column takes one fixed height, so a cell that mixes text and
// icon-only buttons lines them up instead of letting each one's content set its size. The
// padding here is inner padding, horizontal only — the height is already fixed.
const TABLE_ACTION_HEIGHT = "36px";

// Motion: hover lightens the pill to #333 through an opacity-faded white tint (hoverTint — 20%
// white over black is exactly #333) instead of tweening background-color, and a press dips it to
// 0.97 (pressDip). Those are the only transitions: MUI's default background/colour/border tween
// is replaced, so going disabled while a sibling works doesn't smear the pill through grey.
// Doubled `&&` because MUI injects the Button root's own `transition` after this class.
//
// `.is-busy` is the popup CTA spec's processing look (#333, not the translucent disabled black),
// for the one button whose action is in flight while its siblings are merely blocked.
const TableActionButton = styled(Button)(({ theme }) => ({
  height: TABLE_ACTION_HEIGHT,
  minHeight: TABLE_ACTION_HEIGHT,
  padding: "0 16px",
  whiteSpace: "nowrap",
  backgroundColor: "black",
  color: "white",
  fontFamily: "'Inter', sans-serif",
  fontSize: 14,
  fontWeight: 400,
  border: "none",
  "&:hover": {
    backgroundColor: "black",
    border: "none",
    color: "white",
  },
  "&.Mui-disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    color: "rgba(255, 255, 255, 0.6)",
  },
  "&.is-busy": {
    backgroundColor: "#333",
    color: "white",
  },
  "&&": {
    ...pressDip,
    ...hoverTint(theme, { light: "rgba(255, 255, 255, 0.2)", dark: "rgba(255, 255, 255, 0.2)" }),
  },
}));

// A table action's label ↔ spinner, swapped in place (transitions-dev "Text states swap": the
// label lifts 4px and fades as the spinner rises in, 150ms; no blur lane — CLAUDE.md keeps filter
// off the animated list). Both share one grid cell, so the pill keeps the label's width while the
// spinner shows instead of collapsing around it. The spinner mounts only while busy: an idle
// CircularProgress still spins. The faded label stays in the accessibility tree on purpose — it
// is the button's name — and the host button says `aria-busy` instead.
const BusyLabel = ({ busy, children }: { busy: boolean; children: React.ReactNode }) => (
  <Box component="span" sx={{ display: "inline-grid", placeItems: "center" }}>
    <Box
      component="span"
      sx={{
        gridArea: "1 / 1",
        opacity: busy ? 0 : 1,
        transform: busy ? `translate3d(0, -${TEXT_SWAP_DISTANCE}px, 0)` : "none",
        transition: `opacity ${TEXT_SWAP_MS}ms ${EASE_IN_OUT}, transform ${TEXT_SWAP_MS}ms ${EASE_IN_OUT}`,
        "@media (prefers-reduced-motion: reduce)": { transition: "none" },
      }}
    >
      {children}
    </Box>
    {busy && (
      <Box component="span" sx={{ gridArea: "1 / 1", display: "inline-flex", ...swapInSx() }}>
        <CircularProgress size={16} sx={{ color: "white" }} />
      </Box>
    )}
  </Box>
);

export const InfoButton = styled(MuiButton)`
  height: 54px;
  margin-bottom: 10px;
  position: relative;
  border-color: none;
  &.Mui-disabled {
    img {
      opacity: 0.5;
    }
  }
  @media (max-width: 992px) {
    width: inherit;
    height: 54px;
  }
`;

const DialogInfoPaper = styled(MuiDialog)`
  .MuiDialog-paper {
    max-width: 40%;
    min-width: 300px;
    background-color: white;
    border-radius: 18px;
    //box-shadow: none;
    position: relative; /* Ensure child elements like IconContainer can be positioned */
    overflow: visible; /* Allow content to overflow */
    border: 1px solid ${({ theme }) => theme.palette.divider};
    @media (max-width: 560px) {
      // height:350px;
      margin: 12px;
    }
  }
`;

// Opens and closes as a transitions-dev "Modal" like every other popup (components/ScaleTransition),
// rather than MUI's plain Fade. Header's org-acceptance popup shares it.
export const DialogInfo = (props: React.ComponentProps<typeof DialogInfoPaper>) => (
  <DialogInfoPaper {...modalTransitionProps} {...props} />
);

export const InfoBody = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 16px;
  margin-top: 16px;
  p {
    font-size: 16px;
    font-family: Inter, sans-serif;
  }
  a {
    color: black;
    text-underline-offset: 2px;
    font-size: 16px;
    font-family: Inter, sans-serif;
  }
`;

export const Row = (props: GridProps) => <Grid {...props} container alignItems="center" direction="row" />;

export const FilterBlock = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  overflow-x: auto;
  white-space: nowrap;

  /* The strip scrolls horizontally once the tabs outgrow the bar. The Figma has
     no scrollbar, and a classic one both contradicts it and eats 3px of the
     72px bar; scrolling itself (swipe, drag, keyboard focus) is unaffected. */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 600px) {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding-bottom: 0px;
  }
  & button {
    border: 1px solid
      ${({ theme }) => (theme.palette.mode === "dark" ? theme.palette.border.default : theme.palette.border.default)};
    border-radius: 15px;
    text-transform: capitalize;
    padding: 6px 16px;
    transition: none;
    box-sizing: border-box;

    @media (max-width: 600px) {
      /* Holds the Figma's 42px pill (and a comfortable tap target) at the
         smaller mobile type size — 4px of padding left them only 34px tall. */
      padding: 8px 14px;
      font-size: 0.875rem;
    }

    &:hover {
      animation: none;
      transform: none;
      transition: none;
      border: 1px solid
        ${({ theme }) => (theme.palette.mode === "dark" ? theme.palette.border.default : theme.palette.border.default)};
      width: auto;
      height: auto;
      box-sizing: border-box;
    }

    &.active {
      border: 1px solid transparent;
    }

    &:disabled {
      background-color: ${({ theme }) => theme.palette.border.default};
      color: ${({ theme }) => theme.palette.text.primary};
      pointer-events: none;
    }
  }
`;

export const CircularIcon = styled("div")`
  background-color: #d1efff;
  padding: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px; /* Adjust the size as needed */
  height: 64px; /* Adjust the size as needed */
`;

export const Wrapper = styled("div")`
  border-radius: 16px;
  width: fit-content;
  margin: auto;
  min-height: auto;
  max-height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;

  &.error {
    border-color: ${({ theme }) => theme.palette.error.main};
  }

  p {
    margin: 0;
    color: #3d3d3d;
  }

  button {
    margin-top: 10px;
    padding: 6px 42px;
  }

  &.cropping {
    width: 100%;
    height: auto;
  }
`;

export const IconContainer = styled("div")`
  padding: 16px;
  position: absolute;
  top: -40px;
  border-radius: 100%;
  background-color: white;
  left: 50%;
  transform: translateX(-50%);
`;

// export const DialogPopUp = styled(MuiDialog)`
//   .MuiDialog-paper {
//     max-width: 600px;
//     min-width: 300px;
//     background: transparent;
//     border-radius: 18px;
//     //box-shadow: none;
//     border: 1px solid transparent;
//     @media (max-width: 560px) {
//       // height:350px;
//       max-width: 325px;
//       min-width: 300px;
//       margin: 12px;
//     }
//   }
// `;

export const StyledFlagRating = styled(Rating)(({ theme }) => ({
  "& .MuiRating-iconFilled": {
    color: theme.palette.primary.main,
  },
  "& .MuiRating-iconEmpty": {
    color: theme.palette.grey[400],
  },
  "& .MuiRating-iconHover": {
    color: theme.palette.primary.dark,
  },
  "& .MuiRating-icon": {
    fontSize: "1.2rem",
  },
}));

// Styled components for reassign dialog tabs (matching OrgPopUp)
const headerHeight = 64;

const HeaderRow = styled(Box)({
  position: "relative",
  width: "100%",
  height: headerHeight,
  flexShrink: 0,
  display: "flex",
  flexDirection: "row",
  backgroundColor: "#ccc",
  borderRadius: "20px 20px 0 0",
});

const HalfArea = styled(Box)<{ side: "left" | "right"; active?: boolean }>(({ side, active }) => ({
  width: "50%",
  height: headerHeight,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  background: active ? "#ede1dc" : "transparent",
  borderTopLeftRadius: side === "left" && active ? 20 : 20,
  borderTopRightRadius: side === "right" && active ? 20 : 20,
}));

const PillBox = styled(Box)({
  width: 127,
  height: 39.923,
  borderRadius: 20,
  background: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const TabLabelButton = styled(Button)(({ theme }) => ({
  position: "relative",
  height: headerHeight,
  width: "100%",
  minWidth: 0,
  padding: 0,
  color: "#000",
  fontFamily: "Inter, sans-serif",
  fontSize: 14,
  background: "transparent",
  border: "none",
  boxShadow: "none",
  transition: "none !important",
  display: "flex",
  justifyContent: "center",
  textAlign: "center",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  userSelect: "none",
  [theme.breakpoints.down("sm")]: {
    paddingTop: 0,
    alignItems: "center",
  },
  [theme.breakpoints.up("sm")]: {
    paddingTop: 0,
    alignItems: "center",
  },
  zIndex: 4,
  "&:hover": { background: "transparent", border: "none", boxShadow: "none", textDecoration: "none" },
  "&:active": { background: "transparent", boxShadow: "none" },
  "&:focus": { boxShadow: "none" },
}));

export type TrusteeSchemaDeps = {
  isSmallScreen: boolean;
  isLoading: boolean;
  anchorEl: HTMLElement | null;
  selectedMenuId: any;
  navigator: ReturnType<typeof useNavigate>;
  handleOrgClick: (e: React.MouseEvent<HTMLElement>, data: any) => void;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>, data: any) => void;
  handleClose: () => void;
  handleModalOpen: () => void;
  blockTrustee: (address: string) => void;
  setApproveOpen: (open: boolean) => void;
  /**
   * Opens the applicant review (details → deed → approve) for the row whose menu is open. Hosts
   * that don't approve applicants omit it and keep their `setApproveOpen` wiring.
   */
  onReviewApplicant?: () => void;
  /** Document ids awaiting the connected admin's signature (drives the Portal "Sign" action). */
  adminPendingDocumentIds?: Set<number>;
};

export const getTrusteeSchema = ({
  isSmallScreen,
  isLoading,
  anchorEl,
  selectedMenuId,
  navigator,
  handleOrgClick,
  handleClick,
  handleClose,
  handleModalOpen,
  blockTrustee,
  setApproveOpen,
  onReviewApplicant,
  adminPendingDocumentIds,
}: TrusteeSchemaDeps): TableSchema<any>[] => [
  {
    id: "name",
    label: "Trust",
    render: (data) => {
      return (
        <Box sx={{ width: sizing(50), height: sizing(50), display: "flex", flexDirection: "column", gap: 1 }}>
          <Img alt="Thumb" sx={{ width: "100%", borderRadius: "50%" }} src={data?.profilePicture} />
        </Box>
      );
    },
  },
  {
    id: "name",
    label: "Name",
    render: (data) => {
      const renderFlags = () => {
        const icons: React.ReactNode[] = [];
        const totalFlags = Array.isArray(data?.flags) ? data.flags.length : 0;

        for (let i = totalFlags - 1; i >= 0; i--) {
          const hasMessage = true;

          icons.push(
            <Box
              key={i}
              sx={{
                cursor: hasMessage ? "pointer" : "default",
                "&:hover": hasMessage ? { opacity: 0.7 } : {},
              }}
            >
              <DetailsPopup transaction={data?.flags[i]} flag={true} />
            </Box>
          );
        }
        return icons;
      };

      return (
        <Text medium normal sx={{ flexDirection: "column", gap: 1 }}>
          <ClickableContainer>
            <Text contrast>
              <AddressLink
                sx={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  "& a.userAddress, & a.trustAddress": { textDecoration: "none" },
                  "& a.userAddress:hover, & a.trustAddress:hover": { textDecoration: "none" },
                }}
                type="user"
                address={data.address}
                links={false}
                name={data.name}
              />
            </Text>
          </ClickableContainer>
          {(Array.isArray(data.flags) ? data.flags.length : 0) > 0 && (
            <Box sx={{ mb: sizing(10), display: "flex", alignItems: "center", gap: 0.5 }}>{renderFlags()}</Box>
          )}
        </Text>
      );
    },
  },
  {
    id: "organization",
    label: "Organization",
    sx: { width: sizing(60) },
    render: (data) => {
      const orgLabel =
        (data?.orgName && data.orgName !== "-" ? data.orgName : null) ?? data?.organization?.name ?? null;
      const hasOrg = Boolean(orgLabel);

      return (
        <ClickableContainer
          onClick={hasOrg ? (e) => handleOrgClick(e, data) : undefined}
          sx={{ cursor: hasOrg ? "pointer" : "default", pointerEvents: hasOrg ? "auto" : "none" }}
        >
          <Text
            mono
            medium
            sx={{ flexDirection: "column", gap: 1, color: hasOrg ? "text.primary" : "#565656", fontWeight: 500 }}
          >
            {orgLabel ?? "No organization"}
          </Text>
        </ClickableContainer>
      );
    },
  },
  {
    id: "location",
    label: "Location",
    render: (data, _index) => {
      return (
        <>
          <Text mono medium sx={{ flexDirection: "column", gap: 1, color: "text.primary", fontWeight: 500 }}>
            {data?.patronymic ? data?.patronymic : "Not found"}
            <Text mono medium sx={{ flexDirection: "column", gap: 1, color: "#565656", fontWeight: 400 }}>
              {data?.country ? data?.country : "Not found"}
            </Text>
          </Text>
        </>
      );
    },
  },
  {
    id: "lastTxn",
    label: "Last Txn",
    render: (data, _index) => {
      return (
        <>
          <ClickableContainer
            onClick={() => navigator(generatePath(AppRoutes.UserWallet.path, { address: data.address }))}
            sx={{ cursor: "pointer", pointerEvents: "auto" }}
          >
            <Text medium sx={{ color: "text.primary", fontFamily: "monospace", textTransform: "lowercase" }}>
              {data?.lastTxn?.createdAt ? formatRelativeTime(data.lastTxn.createdAt) : "No transactions"}
              <ArrowOutwardIcon
                sx={{
                  color: "black",
                  fontSize: "0.9rem",
                }}
              />
            </Text>
          </ClickableContainer>
        </>
      );
    },
  },
  {
    id: "verified",
    label: "Verified",
    render: (data, _index) => {
      return (
        <>
          <Text mono medium sx={{ flexDirection: "column", gap: 1, "& a": { color: "text.primary" } }}>
            {data?.portfolio.totalVerifiedLandsCount ? data?.portfolio.totalVerifiedLandsCount : "0"}
          </Text>
        </>
      );
    },
  },
  {
    id: "portfolio",
    label: "Portfolio",
    render: (data, _index) => {
      return (
        <>
          <Text mono medium sx={{ flexDirection: "row", gap: 1, "& a": { color: "text.primary" } }}>
            {data?.portfolio.portfolioSum ? toReadable(data?.portfolio.portfolioSum) : "0"}{" "}
            <CurrencyLabel currency={CURRENCY_NAME} />
          </Text>
        </>
      );
    },
  },
  {
    id: "status",
    label: "Status",
    render: (data) => {
      return (
        <>
          <Text mono medium sx={{ flexDirection: "column", gap: 1, "& a": { color: "text.primary" } }}>
            {data.status && data?.role === "user" ? "Unverified" : data.status}
          </Text>
        </>
      );
    },
  },
  {
    id: "actions",
    label: "Actions",
    render: (data) => {
      // Documents this row's trustee/user *created* that still await this admin's
      // signature (matched by id). Approval itself is no longer gated here: an applicant
      // signs nothing while applying, and the deed the approval rests on is executed and
      // uploaded by the admin inside the review ("Review & approve").
      const pendingCreatorDocs = (data?.signedDocuments || []).filter(
        (doc: any) => doc?.creator && adminPendingDocumentIds?.has(doc?.id)
      );
      const signableDocument =
        pendingCreatorDocs.find((doc: any) => doc?.type === DocumentType.VERIFIER_ENGAGEMENT) ??
        pendingCreatorDocs[0] ??
        null;
      const signableDocumentId = signableDocument?.id ?? null;
      return (
        <>
          <Row sx={{ gap: "12px", justifyContent: "start" }}>
            <TableActionButton
              size="small"
              color="primary"
              disabled={isLoading}
              variant="outlined"
              sx={{ textTransform: "none" }}
              onClick={(event) => handleClick(event, data)}
            >
              ...
            </TableActionButton>
            <Menu
              id={`menu-${data.id}`}
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && selectedMenuId === data.id}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              MenuListProps={{
                sx: {
                  padding: 5,
                  "& .MuiMenuItem-root": {
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  },
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  handleModalOpen();
                  handleClose();
                }}
              >
                <RemoveRedEyeOutlinedIcon />
                <Typography sx={{ paddingLeft: 2 }}>Inspect</Typography>
              </MenuItem>
              {(Array.isArray(data?.flags) ? data.flags.length : 0) >= 3 && data?.status === "active" && (
                <MenuItem onClick={() => blockTrustee(data.address)}>
                  <BlockOutlinedIcon sx={{ marginRight: 1 }} /> Block
                </MenuItem>
              )}
              {signableDocumentId != null && (
                <MenuItem
                  onClick={() => {
                    handleClose();
                    navigator(generatePath(AppRoutes.DocumentSigner.path, { documentId: String(signableDocumentId) }));
                  }}
                >
                  <DrawIcon sx={{ marginRight: 1 }} /> Sign{" "}
                  {signableDocument?.type === DocumentType.VERIFIER_ENGAGEMENT ? "Verifier Engagement" : "Document"}
                </MenuItem>
              )}
              {data?.role === "user" && data?.status && (
                <>
                  <MenuItem
                    onClick={() => {
                      if (!onReviewApplicant) {
                        setApproveOpen(true);
                        return;
                      }
                      handleClose();
                      onReviewApplicant();
                    }}
                  >
                    <CheckBoxOutlinedIcon sx={{ marginRight: 1 }} /> Review &amp; approve
                  </MenuItem>
                </>
              )}
            </Menu>
          </Row>
        </>
      );
    },
  },
];

export default Portal;
